import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    productId: 0,
    listId: 0,
    selectLanguage: 1,
    product: [{
            id: 1,
            headline: '普通插管',
            list: [{
                    id: 0,
                    name: '气管插管（带套囊）',
                    img: require('./../assets/img/product/t1-1-1.png'),
                    descImg: require('./../assets/img/product/b1-1-1.png'),
                },
                {
                    id: 1,
                    name: '气管插管（不带套囊）',
                    img: require('./../assets/img/product/t1-1-2.png'),
                    descImg: require('./../assets/img/product/b1-1-2.png'),
                }
            ]
        },
        {
            id: 2,
            headline: '特殊插管',
            list: [{
                    id: 2,
                    name: '双腔支气管插管（左侧）',
                    img: require('./../assets/img/product/t1-2-1.png'),
                    descImg: require('./../assets/img/product/b1-2-1.png'),
                },
                {
                    id: 3,
                    name: '双腔支气管插管（右侧）',
                    img: require('./../assets/img/product/t1-2-2.png'),
                    descImg: require('./../assets/img/product/b1-2-2.png'),
                },
                {
                    id: 4,
                    name: '加强型气管插管',
                    img: require('./../assets/img/product/t1-2-3.png'),
                    descImg: require('./../assets/img/product/b1-2-3.png'),
                }
            ]
        },
        {
            id: 3,
            headline: '可冲洗插管',
            list: [{
                id: 5,
                name: '锥形套囊气管插管',
                img: require('./../assets/img/product/t1-3-1.png'),
                descImg: require('./../assets/img/product/b1-3-1.png'),
            }]
        },
        {
            id: 4,
            headline: '气管切开插管',
            list: [{
                    id: 6,
                    name: '气管切开套管',
                    img: require('./../assets/img/product/t1-4-1.png'),
                    descImg: require('./../assets/img/product/b1-4-1.png'),
                },
                {
                    id: 7,
                    name: '气管切开插管',
                    img: require('./../assets/img/product/t1-4-2.png'),
                    descImg: require('./../assets/img/product/b1-4-2.png'),
                }
            ]
        },
        {
            id: 5,
            headline: '其他附件',
            list: [{
                    id: 8,
                    name: '一次性湿热交换器/过滤器',
                    img: require('./../assets/img/product/t1-5-1.png'),
                    descImg: require('./../assets/img/product/b1-5-1.png'),
                },
                {
                    id: 9,
                    name: '麻醉面罩',
                    img: require('./../assets/img/product/t1-5-2.png'),
                    descImg: require('./../assets/img/product/b1-5-2.png'),
                },
                {
                    id: 10,
                    name: '气管插管管芯针',
                    img: require('./../assets/img/product/t1-5-3.png'),
                    descImg: require('./../assets/img/product/b1-5-3.png'),
                },
                {
                    id: 11,
                    name: '手持压力表',
                    img: require('./../assets/img/product/t1-5-4.png'),
                    descImg: require('./../assets/img/product/b1-5-4.png'),
                }
            ]
        },
        {
            id: 6,
            headline: '机器',
            list: [{
                id: 12,
                name: 'Aquarius 连续性血液净化设备',
                img: require('./../assets/img/product/t2-1-1.png'),
                descImg: require('./../assets/img/product/b2-1-1.png'),
            }]
        },
        {
            id: 7,
            headline: '耗材',
            list: [{
                    id: 13,
                    name: 'Aqualine管路',
                    img: require('./../assets/img/product/t2-2-1.png'),
                    descImg: require('./../assets/img/product/b2-2-1.png'),
                },
                {
                    id: 14,
                    name: 'HF1200滤器',
                    img: require('./../assets/img/product/t2-2-2.png'),
                    descImg: require('./../assets/img/product/b2-2-2.png'),
                }
            ]
        },
        {
            id: 8,
            headline: '预防血栓系列',
            list: [{
                    id: 15,
                    name: 'SCD Express',
                    img: require('./../assets/img/product/t3-1.png'),
                    descImg: require('./../assets/img/product/b3-1.png'),
                },
                {
                    id: 16,
                    name: 'SCD 700',
                    img: require('./../assets/img/product/t3-2.png'),
                    descImg: require('./../assets/img/product/b3-2.png'),
                }
            ]
        },
        {
            id: 9,
            headline: '喉镜系列',
            list: [{
                id: 17,
                name: '喉镜系列',
                img: require('./../assets/img/product/t4-1.png'),
                descImg: require('./../assets/img/product/b4-1.png'),
            }]
        },
        {
            id: 10,
            headline: '呼吸回路系列',
            list: [{
                    id: 18,
                    name: '双旋接口延长管(331/5390)',
                    img: require('./../assets/img/product/t5-1.png'),
                    descImg: require('./../assets/img/product/b5-1.png'),
                },
                {
                    id: 19,
                    name: '双旋接口延长管(331/5661)',
                    img: require('./../assets/img/product/t5-2.png'),
                    descImg: require('./../assets/img/product/b5-2.png'),
                },
                {
                    id: 20,
                    name: '成人呼吸回路(304/6085)',
                    img: require('./../assets/img/product/t5-3.png'),
                    descImg: require('./../assets/img/product/b5-3.png'),
                },
                {
                    id: 21,
                    name: '成人麻醉回路(300/6042)',
                    img: require('./../assets/img/product/t5-4.png'),
                    descImg: require('./../assets/img/product/b5-4.png'),
                }
            ]
        },
        {
            id: 11,
            headline: '脑部与区域血氧检测系统',
            list: [{
                id: 22,
                name: '脑部与区域血氧检测系统',
                img: require('./../assets/img/product/t6-1.png'),
                descImg: require('./../assets/img/product/b6-1.png'),
            }]
        },
        {
            id: 12,
            headline: 'Floton福通系列呼吸机',
            list: [{
                id: 23,
                name: 'Floton福通系列呼吸机',
                img: require('./../assets/img/product/t7-1.png'),
                descImg: require('./../assets/img/product/b7-1.png'),
            }]
        }
    ],
    healthArtical: [
        {
            id: 8,
            month: '2021-3',
            day: '9',
            img: require('./../assets/img/artical/health/13.png'),
            cover: 'static/img/health/news13.png',
            txt: '健康食品',
            title: '七个"健康食品"迷思',
            desc: '我们大多数人可能都以为自己很了解什么是健康食品，该吃什么，不吃什么等等。比如，注意卡路里摄入、选择健康碳酸饮料、少吃巧克力或服用维生素补充剂等。',
            content: `<p> 我们大多数人可能都以为自己很了解什么是健康食品，该吃什么，不吃什么等等。比如，注意卡路里摄入、选择健康碳酸饮料、少吃巧克力或服用维生素补充剂等。<br />&emsp;&emsp;但这样做是否是白费力气呢？英国遗传流行病学家蒂姆·斯派克特教授（Prof Tim Spector）在BBC节目The Spark中为你揭开人们对健康食品的七大迷思：</p>

            <img src="static/img/health/13/1.png" />

            <p>迷思一：要想减肥就要注意卡路里摄入：<br />&emsp;&emsp;许多人在超市购物时，往往会留意标签上的食品热量，如果卡路里过高最好别买。但蒂姆认为，仅仅考虑卡路里摄入会形成“很大弊端”。<br />&emsp;&emsp;例如，男性和女性燃烧卡路里的速度不同，就连同卵双胞胎在吃同一食品时都会有差异。蒂姆说，四分之一的人在吃了高碳水化合物食品后会出现血糖下降，让他们在几个小时后反而更加饥饿。而另外四分之三的人则不会。<br />&emsp;&emsp;不仅如此，蒂姆解释说，卡路里也不尽相同，例如，200卡路里的脂肪和相同卡路里的碳水化合物对你身体的影响未必一样。<br />&emsp;&emsp;同时，尽管卡路里数量一样，但超级加工食品和未加工食品也存在明显区别。超级加工食品可以让你吃完后更饿，结果导致后来吃得更多。  </p>
    
            <p>迷思二：健怡饮料有助减肥: <br />&emsp;&emsp;许多人喜欢喝健怡可乐或饮料（diet coke/drinks）, 认为只要有“diet”这个词就更健康。一些所谓健怡饮料还标榜“零卡”或是低卡。但蒂姆说，那些用于达到零卡与低卡效果的化学物质来自于石蜡以及各种奇奇怪怪的人造化合物。<br />&emsp;&emsp;例如，男性和女性燃烧卡路里的速度不同，就连同卵双胞胎在吃同一食品时都会有差异。蒂姆说，四分之一的人在吃了高碳水化合物食品后会出现血糖下降，让他们在几个小时后反而更加饥饿。而另外四分之三的人则不会。<br />&emsp;&emsp;蒂姆解释说，这些奇怪成份能让我们肠道微生物产生破坏新陈代谢的某些化学物质。也就是说，这些零卡路里的健怡或减肥饮料所带来的所有好处都会被抵消，最后到头来没有任何区别：无论你是想减肥还是控制糖尿病。所以，最好和减肥饮料拉开距离。
    
            <img src="static/img/health/13/2.png" />

            <p>迷思三：所有细菌都不好:<br />&emsp;&emsp; 发酵食品对健康有好处 <br />&emsp;&emsp; 人们越来越意识到，生活在我们消化系统里的肠道微生物越多样化越好。一提到细菌人们往往就会与肮脏或污染联系起来。但其实，有些细菌种类对我们的健康至关重要。 <br />&emsp;&emsp;我们肠道中生活着上万亿的微生物群 - 对我们来说是独一无二的。这也就是为什么双胞胎对同样卡路里的食物反应不尽相同的原因。<br />&emsp;&emsp;蒂姆说，人体大约一半是微生物群，它们不仅对维持人体细胞非常重要，同时也对我们身体中的细菌、真菌、病毒和寄生虫必不可少。99%的微生物生活在我们的肠道中，同时也生活在我们的鼻子、嘴和胃里。<br />&emsp;&emsp;蒂姆称这些微生物对人体免疫系统绝对关键，它们甚至帮助抗击像新冠这样的病毒感染。怎样才能让我们的微生物群更加多样化呢？最容易的是吃发酵食物，例如韩国泡菜（Kimchi）、德国泡菜（kraut）、开菲尔（也称克非尔，kefir）以及康普茶（kombucha）。<br />&emsp;&emsp;其中，Kimchi和kraut都是卷新菜和白菜发酵而成，开菲尔则是用发酵牛奶制成的饮料。</p>
            
            <p>迷思四：我们应该服用维生素补充剂:<br />&emsp;&emsp;蒂姆说，几乎一半的人经常服用维生素，但它们真有好处吗？<br />&emsp;&emsp;蒂姆解释说，一些随机试验表明大多数没有什么证据基础。不过，研究显示那些经常吃维生素药的人更健康，蒂姆说，这是因为他们的生活方式本身就健康的缘故。<br />&emsp;&emsp;即使是对感冒有好处的维生素C ，也是要大剂量才能起作用。但这不等于说我们不应该吃富含维生素的食品，但如果只靠单纯补充维生素药丸未必有益。<br />&emsp;&emsp;<br />&emsp;&emsp;
            
            <img src="static/img/health/13/3.png" />

            <p>迷思五：吃鱼补脑: <br />&emsp;&emsp;鱼对大脑的好处有那么神奇吗？<br />&emsp;&emsp;包括儿童在内的许多人都服用鱼油补脑，提高智力。但欧米伽3 （Omega-3）真有那么神奇吗？<br />&emsp;&emsp;蒂姆认为，饮食结构中包括鱼对我们没害处，然而，人类食鱼的习惯却对地球不利。况且，70%的鱼目前都是人工养殖的，它对环境产生巨大影响。</p>
            <p>迷思六：酒和巧克力对你有害:<br />&emsp;&emsp;蒂姆表示，有时你越是禁止某些食品、人们就越想吃。所以，他尽量避免说哪一种食物不能吃。正相反，蒂姆认为酒和巧克力这两种人们经常被告知不好的食物对我们的肠道微生物有好处，特别是红酒和黑巧克力。<br />&emsp;&emsp;因为这些食品含有大量多酚，它们是植物的天然防御化学物质，为人体肠道微生物提供养料。</p>
            
            <img src="static/img/health/13/4.png" />

            <p>迷思七：一天一个苹果不生病<br />&emsp;&emsp; 多吃不同植物品种 <br />&emsp;&emsp;首先，一天吃一个苹果肯定没有错。但蒂姆建议，如果想要让我们的微生物群多样化，每周要吃30种不同植物。世上有3万种可食的植物，可供我们选择的种类很多。<br />&emsp;&emsp; 我们都知道每天应该吃够5份果蔬，有人建议实际上应该是7份。但即使我们能吃够5份，大多数人每周也总是重复同样的果蔬。有些人每周所吃的植物品种也就5种。<br />&emsp;&emsp;其实，每周30种果蔬不必每种都够80克一份的量，这样想可能就不那么难了。除了果蔬外，还可以包括不同的坚果、种子类、沙拉叶子、香料、豆子和全谷物等等。</p>

            <p>为什么会出现这么多迷思呢？<br />&emsp;&emsp;人们对食品形成诸多误区，原因之一是医学专业人员对营养所知甚少。比如，蒂姆解释说，大多数医生更了解坏血病而不是肥胖症，但我们大多数人都没见过坏血病。<br />&emsp;&emsp;所以，蒂姆建议加强这方面的教育，不光是医疗人员，所有人在学校都应该学习这方面的知识，才能知道怎么照顾自己。<br />&emsp;&emsp;此外，媒体的报道这方面消息时也负有一定的责任。还有，加工食品商更有责任，他们往往赞助营养研究项目，难免就会有一些“动机不纯”。<br />&emsp;&emsp;因此，要想让下一代更健康，就要改变我们对食品的认识，也不能延续同样的营养准则。同时，还要明白加工食品对地球的危害。</p>
            
            <p>资料来源：BBC中文网<br />

            图片来源：网络</p>
         `
        },{
            id: 7,
            month: '2018-12',
            day: '25',
            img: require('./../assets/img/artical/health/11.png'),
            cover: 'static/img/health/news11.png',
            txt: '咖啡',
            title: '新鲜的咖啡到底指的是哪些？',
            desc: '"趁热吃"是生活中经常出现的词语，没有人喜欢吃冷菜冷饭，也证明了大家对于食材新鲜度的喜爱。而追求健康的人们就成为了“新鲜主义者”。对于咖啡而言，“手冲”和“现磨”已经成为告别速溶后的一尺标杆，但是“新鲜”却是一个比前二者更加前卫的概念。',
            content: `<p> "趁热吃"是生活中经常出现的词语，没有人喜欢吃冷菜冷饭，也证明了大家对于食材新鲜度的喜爱。而追求健康的人们就成为了“新鲜主义者”。<br />&emsp;&emsp;对于咖啡而言，“手冲”和“现磨”已经成为告别速溶后的一尺标杆，但是“新鲜”却是一个比前二者更加前卫的概念。<br />&emsp;&emsp;新鲜的咖啡到底指的是哪些？应该如何定义？业内一般认为：新鲜生豆、新鲜烘焙和新鲜研磨，这三者相互结合，方能铸造出一杯真正的新鲜好咖啡。</p>

            <p>新鲜烘焙：<br />&emsp;&emsp;当咖啡豆被烘焙成咖啡色以后，其保质期就已经非常短了，只有短暂的15天。在咖啡豆烘焙完成一周后它的芳香与滋味正好达到了顶峰，在一周以后各种滋味就开始下降了，15天以后就香消殆尽。</p>
    
            <p>而新鲜烘焙的咖啡里含有的营养物质最多，其预防各类疾病的功效也越强。如果有条件，推荐大家自己在家研磨咖啡，已更好地保证咖啡的新鲜度。所以好咖啡，必须是新鲜烘焙的。</p>
    
            <img src="static/img/health/11/1.png" />
    
            <p>新鲜生豆：<br />&emsp;&emsp;一杯好喝的咖啡，60%取决于生豆的质量。同样的豆种、庄园、海拔、种植方法，新产的生豆和老豆在干香、湿香上有很大区别。若咖啡豆商囤积了过去的旧货，在风味上肯定跟新鲜批次的生豆还是会有所差异的，一年以上的生豆，苍老乏味。<br />&emsp;&emsp;新鲜咖啡指的是生豆从处理至烘焙阶段不超过一年，也就是当年新豆。然后从烘焙到包装直至上市销售不超过1个星期，咖啡豆越是新鲜其香味口感越是丰富，而且用意式浓缩咖啡机制作其油脂含量也高，适合制作意大利花式咖啡。并且营养物质释放也多。</p>
    
            <p>新鲜研磨：<br />&emsp;&emsp;研磨代表让咖啡粉更大程度接触水，这使得咖啡中的物质得以快速溶解于水，进而达到萃取的目的，了解萃取的基础，就能够知道事先磨好咖啡粉的利弊。<br />&emsp;&emsp;而当咖啡粉更容易受湿气影响，当咖啡豆受潮时，会影响咖啡的油脂及风味。如果研磨咖啡并让粉暴露于空气中越久，会丧失越多风味与香气。当咖啡粉排掉所有气体十，冲煮来的咖啡会很平淡无味。</p>`
        },
        {
            id: 6,
            month: '2018-12',
            day: '11',
            img: require('./../assets/img/artical/health/10.png'),
            cover: 'static/img/health/news10.png',
            txt: '维生素E',
            title: '维生素E什么时候吃最好？',
            desc: '要想知道维生素e什么时候吃最好？首先让我们先了解下天然维生素E的功效。它是一种强有力的抗氧化剂，具有防衰老，抗癌，维持人体健康的多种功能。可增强人体的免疫力，美白健肤，提高性功能，对延缓衰老，保持肌肤弹性，增强内脏器官功能，保持体力和精力具有明显效果。',
            content: `<p>现在好多人为了让自己的皮肤有弹性，防止肌肤因一些慢性或隐性的伤害而失去弹性直至老化，所以选用维生素e，大家都知道维生素是人体必备的微量元素，都不能少，但是也不能多。那么维生素e什么时候吃最好呢？</p>

            <img src="static/img/health/10/1.png" />

            <p>维生素e怎么吃效果好</p>

            <p>天然维生素E是人体必须的维生素之一，属于脂溶性维生素。保持身体健康的必需营养素，很多人通过补充适宜的维生素来达到养颜护肤、延缓衰老的目的，有维持皮肤，内分泌等功效。那么天然维生素e什么时候吃最好呢？</p>

            <p>要想知道维生素e什么时候吃最好？首先让我们先了解下天然维生素E的功效。它是一种强有力的抗氧化剂，具有防衰老，抗癌，维持人体健康的多种功能。可增强人体的免疫力，美白健肤，提高性功能，对延缓衰老，保持肌肤弹性，增强内脏器官功能，保持体力和精力具有明显效果。</p>

            <img src="static/img/health/10/2.png" />

            <p>常吃维生素e有什么好处</p>

            <p>因为维生素e药在服用后要靠小肠吸收，若胃肠道没有食物，药物会很快被吸收入血。致使维生素E在血液中的浓度增高，并很快通过肾脏和尿道排出体外，使维生素e不能被人体充分利用，大大降低了药物的疗效。那么维生素e什么时候吃最好呢？</p>

            <p>维生素e什么时候吃最好</p>

            <p>天然维生素e什么时候吃最好呢？可以在每日中饭或晚饭后半个小时内服用一粒天然维生素e。可以饭后一个小时内服用。天然维生素E的功效是美容和延缓衰老，皮肤干燥或者皮肤过敏者还可以用维生素e来护理，具体就是把胶囊扎破，涂抹在脸部。每天坚持服用，祛斑、锁水、抗老化功效看得见。此外，内服同时配合外用，效果更佳。</p>

            <p>早上和晚上都是最好的时间。晚上睡觉的时候，人体的吸收能里更强。因为在睡觉的时候，人体需要大量的能量来修复身体，让早上的我们更有精神，而且在发育时期晚上也是长身体的时候。因此早晚服用是最佳时间。</p>`
        },
        {
            id: 5,
            month: '2018-09',
            day: '23',
            img: require('./../assets/img/artical/health/08.png'),
            cover: 'static/img/health/news8.png',
            txt: '维生素D',
            title: '骨质疏松高危人群要合理补充活性维生素D',
            desc: '要问骨质疏松怎么办，不少人都知道要“补钙”。喝牛奶、吃钙片……补钙手法层出不穷。但这些吃下去的钙是否就能起到防治骨质疏松的效果呢？实际上单纯补钙远远不够，还要补充维生素D。',
            content: `<p>要问骨质疏松怎么办，不少人都知道要“补钙”。喝牛奶、吃钙片……补钙手法层出不穷。但这些吃下去的钙是否就能起到防治骨质疏松的效果呢？实际上单纯补钙远远不够，还要补充维生素D。</p>

            <p>维生素D缺乏是“骨松”普遍现象</p>

            <p>骨质疏松症是以骨量减少、骨的微观结构退化为特征，致使骨的脆性增加，容易发生骨折的一种全身性骨骼疾病。由于人们对其防治认识的相对薄弱，大多数人认为单纯补钙就可以解决问题了。因此，经常会听到患者家属问：“为什么一直在补钙，家里的老人还是容易骨折？”是补钙的力度还不够吗？非也！很多时候补钙效果不佳，往往是缺乏了促进钙吸收的物质——维生素D。</p>

            <img src="static/img/health/8/1.png" />

            <p>钙是制造骨头的原料之一，但钙还需要维生素D帮助。研究证实，没有维生素D的参与，人体对膳食中钙的吸收达不到10%。维生素D合并钙剂，是目前预防骨质疏松的良方。</p>

            <p>特殊人群补充活性维生素D更好</p>

            <p>一般来说，普通人每天应至少补充维生素D200国际单位，才能起到预防骨质疏松的作用。人体主要是通过晒太阳来合成维生素D，占维生素D供给的90%。通过饮食摄入的维生素D很少。现在外出活动大多数人会涂抹防晒霜，主要怕紫外线的照射，其实只要露胳膊晒15分钟就足够合成一天所需的维生素D。</p>

            <img src="static/img/health/8/2.png" />

            <p>这两种途径获取的维生素D，都是没有生物活性的普通维生素D。普通维生素D只有在肝脏经过羟化作用转变成α-骨化醇 (25－羟基维生素D3)，再在肾脏进一步羟化转变为骨化三醇 (1，25－二羟基维生素D3)后，才具有生物效应。因此，α-骨化醇和骨化三醇又被称为活性维生素D。对于肝肾功能的正常人来说，将普通维生素D转换为活性维生素D是很容易实现的。但由于老年人活动能力下降、以及暴露在阳光下的时间减少等原因，摄取的维生素D往往不足，加之大多数老年人肝、肾功能已经自然衰退，羟化酶水平量和活性的下降，将普通维生素D转换为活性维生素D的功能减弱。因此，他们需要额外补充活性维生素D，达到预防骨质疏松的效益。</p>`
        },
        {
            id: 4,
            month: '2018-09',
            day: '01',
            img: require('./../assets/img/artical/health/07.png'),
            cover: 'static/img/health/news7.png',
            txt: '卡路里',
            title: '想瘦不想动，饱腹低卡路里的食物存在吗？',
            desc: '吃什么能减肥?这大概是所有想要控制体重的人都想知道的终极谜题。饱腹低卡路里的食物真的存在吗?什么是低卡路里食物?卡路里，是一种能量单位，现在仍被广泛使用在营养计量和健身手册上，关心减肥的人应该都听说过。1 克水在 1 大气压下升高 1 摄氏度需要的热量，就是 1 卡路里......',
            content: `<p>吃什么能减肥?这大概是所有想要控制体重的人都想知道的终极谜题。饱腹低卡路里的食物真的存在吗?</p>

            <p>什么是低卡路里食物?<br />&emsp;&emsp;卡路里，是一种能量单位，现在仍被广泛使用在营养计量和健身手册上，关心减肥的人应该都听说过。1 克水在 1 大气压下升高 1 摄氏度需要的热量，就是 1 卡路里，1000 卡路里就是 1 大卡。</p>

            <p>身体在吃东西消化吸收整个过程中，其实是需要消耗热量的。如果食物本身的热量很低，运动量大时吃低热量食物能迅速补充能量，快速排除体外，不会在体内累积，就不会形成脂肪。同理，如果摄入的食物热量较高，又不运动(消耗的热量少)，身体就会把多余的热量用肥肉的形式储藏起来，结果就是肥胖。</p>

            <img src="static/img/health/7/1.png" />

            <p>▲粗粮组-燕麦<br />&emsp;&emsp;美国《时代》杂志评选的“全球十大健康食物”中燕麦位列第五，是唯一上榜的谷类。虽说燕麦热量并不比大米低，可它消化吸收慢，饱腹感特别好，所以少吃点也不会饿。燕麦中水溶性膳食纤维分别是小麦和玉米的4.7倍和7.7倍，能促进肠胃蠕动，利于排便。更难得的是，作为主食，它还含有多种维生素以及各种矿物质，每100克燕麦粉中维生素E高达15毫克，推崇燕麦美容养颜的不是没有道理。</p>

            <p>▲零食组-酸奶<br />&emsp;&emsp;酸奶也是很好的低热量减肥零食，每100克酸奶含有约72大卡。而酸奶富含蛋白质、钙等物质，还含有大量乳酸菌，在补充身体营养的同时又可以刺激肠胃，加速身体排毒。最让减肥女性们惊喜的是，燃烧脂肪的重要元素——B族维生素，在发酵后会增加。因此酸奶有很强的饱腹感，特别适合餐前饮用!</p>

            <p>▲蔬菜组-芹菜<br />&emsp;&emsp;芹菜富含食物纤维，被称为“高纤维食物”，可刺激胃肠蠕动，利于排便。同时芹菜的热量很低，每100克芹菜中含有蛋白质2.2克、脂肪0.3克、糖类1.9克，一棵芹菜大约只含有4到5卡路里的热量。另外，芹菜营养丰富，含有较多的钙，磷、铁及胡萝卜素、维生索C、维生素P等，长期以来既作食用，又作药用。</p>

            <p>▲水果组-苹果<br />&emsp;&emsp;每100克苹果仅含有56大卡热量，且苹果是少数含有胶质的水果之一，因此苹果可以减慢消化吸收的速度，增强饱腹感。其次，苹果含有的纤维素和大量水分可以涨满你的胃，减少饥饿感。另外，其独有的苹果酸，可以加速代谢，减少下身的脂肪，而且它含的钙量比其它水果更丰富。</p>

            <p>不难发现，上面这些食物都有两个特点：热量低;饱腹。不过，就算热量低并且饱肚子，对于减肥来说依旧不完美，还有最关键的一条：控制量。</p>`
        },
        {
            id: 3,
            month: '2018-08',
            day: '06',
            img: require('./../assets/img/artical/health/06.png'),
            cover: 'static/img/health/news6.png',
            txt: '刷牙',
            title: '健康锦囊｜这些年你都刷对牙齿了吗？',
            desc: '大家都知道牙齿很重要，但就是懒，除了做不到每天刷2次牙，有些人对于刷牙的幅度、力度、时间……其实都不清楚。所以结果就是牙菌斑、牙结石“无穷无尽”，导致蛀牙、牙龈炎、牙周炎等口腔疾病，轻则刷牙出血，重则引发头痛、败血症等。',
            content: `<p>大家都知道牙齿很重要，但就是懒，除了做不到每天刷2次牙，有些人对于刷牙的幅度、力度、时间……其实都不清楚。所以结果就是牙菌斑、牙结石“无穷无尽”，导致蛀牙、牙龈炎、牙周炎等口腔疾病，轻则刷牙出血，重则引发头痛、败血症等。</p>

            <p>究竟该怎样刷牙?</p>

            <p>1. 刷牙的力度<br />&emsp;&emsp;刷牙具体应该多大力度呢?看起来有点难以把握，因为不同的人在刷牙时所用的力度都是不同的。太轻不能去掉牙齿上面的牙垢，而刷牙用力过大，也会破坏牙齿上的保护膜，损伤牙齿。科学的刷牙用力程度大约在150克。高级一点的电动牙刷会有力量过大的报警提示。</p>

            <img src="static/img/health/6/1.png" />

            <p>2.刷牙的幅度<br />&emsp;&emsp;刷牙的幅度，大概很多人都没认真想过。正确的方式是一种小幅度的水平运动，在一到两颗牙的宽度为宜，从前到后、从后到前，一路刷过去。因为刷牙幅度太大的话，力度就不好控制，越是“不拘小节”的人，越是容易刷坏牙齿。</p>

            <p>3. 刷牙的时间<br />&emsp;&emsp;刷牙的幅度力度都对了，时间不够也不行，刷牙至少要2分钟。你想想啊，每颗牙齿有3个面要刷，里里外外、上上下下，真的要刷干净，Chris觉得2分钟都未必够。实在做不到的话，或许可以考虑拿手表、手机设个倒计时，再不然，就买一支电动牙刷吧。</p>

            <p>为什么用电动牙刷的人越来越多，除了省力、有趣，最主要的原因应该是“规范”，使用电动牙刷，力度、时间基本就不用担心了。例如附带计时器，帮助刷够2分钟时间。需要提醒的是，电动牙刷每三个月要更换一次新的刷头，并不是一支电动牙刷就搞定一切了。如果你觉得电动牙刷太贵，仍然坚持手动刷牙，也是可以的，选择牙刷的根本其实就是软毛OR硬毛，设计感那些都是其次。</p>

            <p>4. 牙刷软毛好还是硬毛好?<br />&emsp;&emsp;推荐选软毛，因为硬毛牙刷虽然感觉上刷起来比较干净，但是越硬的毛，越容易伤害牙齿和牙龈。但也不必刻意挑选“超软”“极软”的牙刷。因为太软的牙刷毛确实清洁效果不好，这样就比较难达到去除牙缝里食物残渣及菌斑的目的了。</p>

            <p>最后，总结一下正确的刷牙方法,每天刷牙两次，每个牙面都要刷，放在牙齿和牙龈交界的地方，左右轻轻震颤,力度不要太大，每次最少两分钟。</p>`
        },
        {
            id: 2,
            month: '2018-04',
            day: '10',
            img: require('./../assets/img/artical/health/04.png'),
            cover: 'static/img/health/news4.png',
            txt: '运动',
            title: '过度运动伤害肠道 究竟该怎么运动？',
            desc: '研究发现，当一个人过度运动时，肠道细胞便容易受到损坏，肠道也容易有漏洞、渗漏。肠道原本就有一些致病性、内生性毒素，当肠道健康时，这些致病性、内生性毒素会乖乖待在肠道、不会乱跑。一旦肠道有漏洞，肠道中的毒素就可能跑进血流，而这种“运动性肠胃症状”可能导致一......',
            content: `<p>过度运动，肠道细胞容易受损害</p>

            <p>研究发现，当一个人过度运动时，肠道细胞便容易受到损坏，肠道也容易有漏洞、渗漏。肠道原本就有一些致病性、内生性毒素，当肠道健康时，这些致病性、内生性毒素会乖乖待在肠道、不会乱跑。一旦肠道有漏洞，肠道中的毒素就可能跑进血流，而这种“运动性肠胃症状”可能导致一些急性或慢性病症。</p>

            <p>研究人员也观察到，一个人运动两小时，运动程度达“最大摄氧量”的60%，似乎就是一个门槛，无论身体、体能状况如何，只要超过这个运动门槛，肠道损坏风险就会明显上升。若在炙热环境的环境下跑步，肠道失调状况更是会加剧。</p>

            <img src="static/img/health/4/1.png" />

            <p>特殊肠道疾病患者最好做低、中度运动</p>

            <p>研究认为，大肠激躁症患者、发炎性肠道疾病患者若做低度、中度运动，或许较有好处。虽然在这篇期刊论文中，研究人员并没有研究激烈运动会对大肠激躁症、发炎性肠道疾病患者造成哪些影响，但激烈运动、运动过量也很可能对这些患者造成不利冲击。</p>

            <p>研究首席作者澳洲蒙纳许大学营养、营养治疗与食品学学者里卡多?寇斯塔表示，虽然研究显示，过度运动会损害肠道完整性、功能性，但有些恶化因素是可以控制，若采取一些防治策略，或可帮助减轻伤害。</p>

            <p>那么究竟该怎么运动，才能尽可能减少对肠道的伤害，又能锻炼身体呢?</p>

            <p>1. 运动频率：间隔时间不超过72小时<br />&emsp;&emsp;有氧运动建议每天都做或每周的大多数天做，不可间隔时间太长，尽量不要连续两天不运动。因为运动有一个累计效益，超过72小时不运动，前边运动产生的健康效益就会大打折扣。</p>

            <p>2. 运动时间：每天半小时以上<br />&emsp;&emsp;每天的最佳运动时间推荐30分钟以上，可分段完成，每次至少10分钟。原则上，一次性持续运动不建议超过1小时，尤其是40岁以上的人。<br />&emsp;&emsp;因为一次性运动时间过长对关节不好。所以可以分两三个时间段来运动，能达到同样的效果，还可以打破久坐不动的不良习惯。对于减肥来说，每次运动持续10分钟，脂肪就已经开始消耗了。</p>

            <p>3. 运动总量：每周150分钟以上<br />&emsp;&emsp;目前国内外推荐的维持健康益处的运动量为每周150分钟以上。运动量太少，达不到对健康有益的效果。<br />&emsp;&emsp;运动量可根据不同年龄、性别、体质、运动习惯等适当调整，如果运动量过大，容易产生关节磨损、肌肉拉伤甚至心肺功能受损等更严重的问题。</p>`
        },
        {
            id: 1,
            month: '2018-03',
            day: '24',
            img: require('./../assets/img/artical/health/03.png'),
            cover: 'static/img/health/news3.png',
            txt: '睡觉',
            title: '为什么每天都疲惫不堪？六个习惯让你睡不好',
            desc: '为什么你一天睡8个小时，却依然总是感觉疲惫不堪呢？这有可能与你的睡眠习惯有关。近日，英国《每日邮报》上的一篇文章揭示了六个不利于提高睡眠质量的习惯，快来看看你有没有中招。',
            content: `<p>为什么你一天睡8个小时，却依然总是感觉疲惫不堪呢？这有可能与你的睡眠习惯有关。近日，英国《每日邮报》上的一篇文章揭示了六个不利于提高睡眠质量的习惯，快来看看你有没有中招。</p>

            <p>习惯1：开着灯睡觉<br />&emsp;&emsp;睡眠专家Olivia Arezzolo指出，影响你睡眠质量的不仅仅只有熬夜刷手机和平板电脑，还有整夜陪伴你入睡的灯光。<br />&emsp;&emsp;一项发表在《临床内分泌和新陈代谢杂志》上的研究发现，卧室中的灯光（包括台灯和顶灯）能够抑制嗜睡激素褪黑激素90分钟，导致睡眠时间更短、入睡更浅。<br />&emsp;&emsp;解决方法：如果你实在没有办法避免这些灯光或者不适应关灯睡觉，你可以在入睡时戴上蓝色遮光眼镜，或者使用光线更柔和的灯。</p>

            <img src="static/img/health/3/1.png" />

            <p>习惯2：关上闹钟后继续睡觉<br />&emsp;&emsp;很多人习惯在清晨闹铃响后按下止闹按钮继续睡一会儿。实际上，在闹铃一响时就起来对身体更好。有研究发现，多睡的10分钟根本无法为你增加活力，反而受干扰的睡眠会让人更加疲倦。同时，对于那些经常熬夜的人来说，闹钟的震动会干扰睡眠的深度阶段。而这个阶段正是身体正在恢复精力的状态。<br />&emsp;&emsp;解决方法：如果无法在闹钟一响时就起床，你可以在闹钟上贴上一些让人兴奋的励志slogan，这可以帮助你更有动力起床。</p>

            <p>习惯3：临睡前洗热水澡<br />&emsp;&emsp;有些人习惯在临睡前的洗个热水澡，这样可以帮助他们感到放松，但这个习惯可能不利于你的睡眠质量。<br />&emsp;&emsp;这主要是由于热水浴会使身体体温升高，而睡意却往往是在体温下降后来临。如果你总在临睡前洗热水澡的话，很可能入睡更加困难。<br />&emsp;&emsp;解决方法：提前你的洗澡时间。睡眠专家建议，至少在临睡前的一个小时洗热水澡。</p>

            <img src="static/img/health/3/2.png" />

            <p>习惯4：睡前工作太晚<br />&emsp;&emsp;许多上班族经常把工作带回家完成。深夜工作不仅不利于平衡工作和生活，还会严重破坏你的睡眠。研究表明，临睡前工作会让你的大脑进入高度活跃的α脑波状态，从而延长进入深度睡眠所需的时间。<br />&emsp;&emsp;解决方法：淋浴后不要再继续工作，你可以做一些有助于放松的活动，一种放松活动，比如读书、和伴侣聊天或者听轻音乐。</p>

            <p>习惯5：睡前饮酒过量<br />&emsp;&emsp;很多人认为睡前饮酒能够助眠，但一些研究表明，大量饮酒不利于你的睡眠。Olivia Arezzolo表示，酒精的主要成分是糖，它像咖啡因一样会刺激身体。<br />&emsp;&emsp;解决方法：可以在睡前喝喝一杯加柠檬的苏打水替代，或者在睡前至少三个小时前喝点酒。</p>

            <p>习惯6：失眠却没有寻求帮助<br />&emsp;&emsp;有数百万人正在经受着失眠的苦恼，但并非所有人都向专业医生寻求帮助，这不利于缓解你的痛苦。<br />&emsp;&emsp;解决方法：尽早咨询专业医生，并做与过度疲劳相关的检查。</p>`
        },
        {
            id: 0,
            month: '2018-02',
            day: '02',
            img: require('./../assets/img/artical/health/02.png'),
            cover: 'static/img/health/news2.png',
            txt: '健康',
            title: '【健康】五大坏习惯正在偷走你的健康！',
            desc: '在人的一生中，睡眠占去了我们三分之一至四分之一的时间，睡眠对我们的重要性不言而喻。好的睡眠是高质量工作和生活质量前提和保障。相信大家都承受过睡眠不足的煎熬，但是睡眠时间过长是否有利于我们身体呢？接下来就让我们一起探索有关睡眠的科学认识。',
            content: `<p>在人的一生中，睡眠占去了我们三分之一至四分之一的时间，睡眠对我们的重要性不言而喻。好的睡眠是高质量工作和生活质量前提和保障。相信大家都承受过睡眠不足的煎熬，但是睡眠时间过长是否有利于我们身体呢？接下来就让我们一起探索有关睡眠的科学认识。</p>

            <p>误区一：熬夜后可在第二天补充睡眠<br />&emsp;&emsp;不知道大家有没有这样的经历，经过一晚熬夜以后，本以为身体犯困可以很轻松地入睡，但到了第二天早晨却仍然无法入睡，辗转难眠。其实我们的睡眠是受身体生物钟的调节。前一天晚上熬夜，不仅使我们无法补充到充足的睡眠，无法充足地获得第二天的工作精力，而且使我们原本的生物钟变得紊乱使我们在接下来的几个晚上，睡眠节奏都会受到影响。</p>

            <img src="static/img/health/2/1.png" />

            <p>误区二：酒精可帮助睡眠<br />&emsp;&emsp;许多人都有这样的感受，在偶尔一两次喝酒以后，能够很快的入睡。于是就以为喝酒可以帮助入睡，其实不然。酒精在体内分解后物质对人的睡眠睡眠质量是有损伤的，而且长期喝酒来帮助入睡的人，会对酒精产生心理上依赖性。使自己难以在自然放松的状态下，迅速低达到入睡阈值。</p>

            <p>误区三：睡眠时间越长越好<br />&emsp;&emsp;人的一个睡眠周期分为快速动眼期和慢速动眼期。一般一个晚上会经历四五个周期，也就是大概七八个小时，便能获得充分的睡眠。若时间过，长大大脑会变得昏昏欲睡，反而不利于我们第二天的工作。但睡眠时间的长短也不是绝对的。有的人一天睡四五个钟醒来后亦是精神饱满，老人因为身体开始退化，生长激素无需努力工作，因此睡眠时间相对较短；而相对于婴儿一天则睡十多个小时。这些都是自然定律，因此我们的睡眠时间严格规定长短，而是因人而异。</p>

            <img src="static/img/health/2/2.png" />

            <p>误区四：“数羊”可帮助入睡<br />&emsp;&emsp;不知道什么时候开始，人们在失眠的时候开始流传“数羊”的方法，希望就借此能够快速进入睡眠，其实不然。有研究表明，通过“数羊”入睡的时间比平常入睡时间还要长。研究人员认为，属羊方法太过枯燥，对人的入睡并无帮助。在失眠的时候，我们可以幻想一些美好的景色使人放松下来，缓解紧张焦虑的情绪，帮助自己安然入睡。</p>

            <p>误区五：睡觉侧向右边有好处<br />&emsp;&emsp;有些人睡觉往左侧会压迫到心脏，对身体有危害。其实科学研究表明，人在入睡后会经历几次翻身，并且这种翻身对睡眠是有益的，翻身的时候可防止褥疮、有利于肌肉的放松，可提高睡眠质量。</p>`
        },
    ],
    healthArticalId: 0,
    travelArtical: [{
            id: 3,
            month: '2019-01',
            day: '15',
            img: require('./../assets/img/artical/health/12.png'),
            cover: 'static/img/health/news12.png',
            txt: '赛道',
            title: '专治各种不服 解析纽博格林赛道',
            desc: '如果一款性能车，没有上过这条赛道，并在9分钟内跑完全程，那么它的"性能"二字就会被消费者所怀疑，如果一位车手，没有上过这条赛道，并取得冠军，那么他在其他比赛所取得冠军的含金量也会有所下降。对于赛车爱好者来说，这是一条神一般的赛道，它就是--纽博格林赛道。',
            content: `<p>如果一款性能车，没有上过这条赛道，并在9分钟内跑完全程，那么它的"性能"二字就会被消费者所怀疑，如果一位车手，没有上过这条赛道，并取得冠军，那么他在其他比赛所取得冠军的含金量也会有所下降。对于赛车爱好者来说，这是一条神一般的赛道，它就是--纽博格林赛道。</p>

        <p>纽博格林赛道处于德国境内，在科隆市西北约55英里。纽博格林曾经主办过卢森堡的F1大奖赛，所以又被称为卢森堡赛道。赛车场在1984年开幕，第一场比赛就是欧洲F1大奖赛，结果由法国车手普罗斯特胜出。翌年它主办了德国的F1大奖赛，但是之后就在F1界中沉默了一段漫长的岁月。到了1995年，赛道才再次得到主办欧洲F1的权利。让迈克尔-舒马赫乘势在他的同胞面前扬威。</p>

        <img src="static/img/health/12/1.png" />

        <p>赛道转弯<br />&emsp;&emsp;关于纽布格林赛道到底有多少个转弯一直存在很多争论，答案多种多样。官方的统计结果是有88个左转弯和84个右转弯。1971年Nordschleife赛道重新修建之后，这个数字变成了33个左转弯和40个右转弯。</p>

        <p>Nordschleife赛道各段有许多是以世界闻名的名字命名的。经过Hatzenbach（当地一条小溪的名字）弯--一系列比较缓的弯之后，赛道沿着山坡向下到了Hocheichen（德语"高大的橡树"之意）。过了桥之后是Flugplatz（德语"机场"）弯，然后很快就经过Schwedenkreuz（德语"瑞典十字"的意思）到了Aremberg（当地一个村庄的名字）。然后是一个很陡的下坡从桥下穿过，再经过Fuchsrohre（德语"狐狸洞"之意）之后又开始上坡到了Adenauer Forst弯，这个名字源自Adenau当地的一片树林，是一个非常急的S弯。经过一个名叫Metzgersfeld（德语"屠宰场"）的左手弯后是一系列下坡弯，通向Breidscheid（当地村庄名）-整个赛道的最低点，海拔350米。而整个赛道的最高点是Hohe Acht（德语"制高点"）。不得不提到的是Karussell(德语中"旋转木马"的意思)弯，这是一个接近180度的转弯，所有赛车经过的时候都战战兢兢。</p>

        <p>不但是赛道本身难度很大，Eifel当地的气候也增加了赛场上的未知因素。二战前纽布格林历史上最为成功的车手是Rudolf Caracciola。他不但在开幕战Eifel赛中夺冠，更摘取了1928年、1931年、1932年、1937年和1939年共5次德国大奖赛的桂冠，并且还夺得了另外3场Eifel赛的冠军（分别在1931年、1932年和1935年）。Eifel是当时与国际汽车大奖赛齐名的比赛，跟德国大奖赛是同级别赛事，因此这等于是每年在纽布格林赛道上会进行两场F1比赛。在赛车运动最为盛行的1934年到1939年间，每场比赛都有超过200000的观众，尽管当时人们基本上还没有自己的汽车，比赛前后，铁路公司不得不设置专列，把各地的人们送往Adenau。</p>`
        },
        {
            id: 2,
            month: '2018-10',
            day: '09',
            img: require('./../assets/img/artical/health/09.png'),
            cover: 'static/img/health/news9.png',
            txt: '旅行',
            title: '每个人心中旅行的意义是什么？',
            desc: '旅行是一种心态的调整，让你看到更精彩的世界。这句话是没错的，因为当我们非常的浮躁，或者有很多烦心事的时候，旅行就成了解决烦心事的一个方法之一，我们可以看看这美好的世界，换一个不一样的环境，去思考问题，换一个不一样的环境去生活，我们可能会静下心来想更多的东......',
            content: `<p>有时候我们旅行是为了缓解我们工作上的压力，也是为了看更美好的风景，沉淀一下自己放空一下自己，然而每个人对旅行的态度都是不一样的，每个人对旅行的看法也是不一样的，你觉得旅行的意义是什么呢？</p>

        <p>旅行是一种心态的调整，让你看到更精彩的世界。这句话是没错的，因为当我们非常的浮躁，或者有很多烦心事的时候，旅行就成了解决烦心事的一个方法之一，我们可以看看这美好的世界，换一个不一样的环境，去思考问题，换一个不一样的环境去生活，我们可能会静下心来想更多的东西，这样我们回来之后才能真的解决很多心事。</p>

        <img src="static/img/health/9/1.png" />

        <p>旅行让你感知一个迷茫的世界，顺其自然而无所畏惧的未知的世界，也许你现在的你还是一个井底之蛙，还生活在属于自己的那一片天。旅行，它是一种看到世界的方式，他也是能让我们的视野更加开拓，想问题看问题的，视角也会更加的广。</p>

        <p>旅行虚让你学会谦虚，让你走出你的安逸之处，以全新的方式去感受世界。爱旅行的人，一定有着与众不同的生活态度，你会发现那些喜欢旅行的人，她们的性格都是比较开朗活泼的，对待很多事情也会有更广更大的视角，去看，不会一味地因为一个小方面而区局限自己，这就是生活态度的转变，都出去旅行接触的人越多，你就会被这个世界上的其他生活态度所感化，因此也会对你自己的一些态度会有一些多多少少的改变的。</p>

        <img src="static/img/health/9/2.png" />

        <p>只要你有一颗享受美感受美的心，即使花着比别人多的钱耗费者比别人少的时间一样能够感觉到大自然的灵魂，旅行，就是有机会让你去尝试各地的美食各地的风土人情，让你认识这个世界的魅力所在，也许你一味的只会局限于自己的一种饮食习惯而不去尝试新的东西，这样你就会无法发现世间的美，这也是旅行最重要的所在地吧！</p>

        <p>最后一个旅行教会我们的事一种不妥协，勇敢向前去追求自己的梦想的一种决心，我们需要的是有一定的决心，去收拾好行李，整装出发也是给我们人生做一个真正的转折点，旅行也是让我们能够重新的认识了自己，你可以通过旅行做到很多事情，这难道不是对自己的一种成长吗？其实是的，没错，旅行也是对自己的一种成长。</p>`
        },
        {
            id: 1,
            month: '2018-05',
            day: '07',
            img: require('./../assets/img/artical/health/05.png'),
            cover: 'static/img/health/news5.png',
            txt: '名峰',
            title: '一次性认清阿尔卑斯山脉十大名峰',
            desc: '石丹峰位于上瓦尔登和下瓦尔登的交界处，峰顶海拔1898米。也是游客们热衷的山峰。从卢塞恩出发，乘火车前往施坦斯，步行5分钟前往山谷站，乘坐敞篷索道缆车前往Klti，可换乘CabriO高空缆车前往石丹峰。自1893年起，敞篷木制车厢就从施坦斯安静地驶往石丹峰。',
            content: `<p> 一、石丹峰（stanserhorn）<br />&emsp;&emsp;石丹峰位于上瓦尔登和下瓦尔登的交界处，峰顶海拔1898米。也是游客们热衷的山峰。从卢塞恩出发，乘火车前往施坦斯，步行5分钟前往山谷站，乘坐敞篷索道缆车前往Klti，可换乘CabriO高空缆车前往石丹峰。自1893年起，敞篷木制车厢就从施坦斯安静地驶往石丹峰。</p>

        <p>起点位于中间站的高空缆车最吸引人的地方之一就是敞篷车顶平台。站在双层全景车厢的车顶会带给人一种震撼的感觉，近距离感受缆车在立柱之间运行的状态，尽情享受风吹过脸庞的舒适，欣赏壮丽的美景——头顶没有任何缆索。在山顶漫步环游时，护林员会非常高兴帮助游客辨别鲜花和山峰。途中，游客还可以欣赏到土拨鼠，造访绕轴自传的旋转餐厅“Rondorama”。</p>

        <img src="static/img/health/5/1.png" />

        <p>二、雪朗峰(Schilthorn)<br />&emsp;&emsp;雪朗峰完全是因为007系列影片之一《女王密令》而声明鹊起的一座山峰，《女王密令》中惊心动魄的打斗场面在此拍摄，电影的广泛影响带来了世界各地的游客。它海拔2970米，位于因特拉肯正南处的群山之中、少女峰旁。自1967年起，四线高空缆车就开始把游客从劳特布龙嫩山谷施特歇尔贝格送往山顶。</p>

        <p>在山顶可以360度欣赏包括艾格峰、少女峰在内的“瑞士天际线”美景以及黑森林地区、汝拉山脉和勃朗峰，缆车中间站博格的“天际线漫步”和“惊险漫步”使游客真正无障碍地欣赏脚下与众不同的美景。山顶有旋转餐厅Piz Gloria享用美味佳肴。如今，游客可以追寻詹姆斯·邦德的足迹，参观“邦德世界007”互动冒险展览，或者感受全新的“007星光大道”。还可在欣赏美丽全景的旋转餐厅Piz Gloria享用詹姆斯·邦德香槟早餐、007汉堡包以及其他美味佳肴。</p>

        <img src="static/img/health/5/2.png" />

        <p>三、魏斯峰（Weisshorn）<br />&emsp;&emsp;魏斯峰海拔4505米，地处采尔马特和Anniviers山谷的谢尔和维斯帕之间，是奔宁阿尔卑斯山的一部分，也是围绕着采尔马特的一系列海拔超过4000米的山峰之一。</p>

        <p>自1861年爱尔兰的物理学家 John Tyndall首次登上魏斯峰至今，魏斯峰在很多登山者心中是阿尔卑斯山脉中最漂亮的山峰，其形状极似另一座“世界上最美丽的山峰”——位于南美安第斯山脉的阿尔帕玛尤峰（Alpamayo，5947米）。</p>

        <p>四、多姆峰（Dom）<br />&emsp;&emsp;多姆峰海拔4545米，是阿尔卑斯山的第三高峰、瓦莱阿尔卑斯山第二大山群米沙贝尔山群（Mischabelgruppe）的最高点，也是完全位于瑞士境内的瑞士实际意义上的最高峰。多姆峰位于采尔马特的北部兰达东部，与魏斯峰隔河谷相对，它的东侧峡谷则是瓦莱州另一度假胜地萨斯费。</p>

        <p>多姆在德语中是穹顶的意思，也可理解为教堂。而这座山峰以此为名，正是在Sitten cathedral教堂的rCanon对山峰周围进行考察的第一人。以前山峰名为Mischabel，来自德语干草叉，因为山体的最高峰彼此靠近。</p>

        <p>五、杜富尔峰（Dufourspitze）<br />&emsp;&emsp;杜富尔峰海拔4634米，是阿尔卑斯山第二高峰，向西正对马特洪峰，是位于瑞士和意大利边境的罗莎山群的最高点。杜富尔峰属于瓦莱阿尔卑斯山，北临瑞士小镇采尔马特。</p>

        <p>周围既是登山圣地，也是拥有超过200公里滑道的世界著名高山滑雪场，也有可进行自由滑雪的山峰。在19世纪早期开始的一系列罗莎山峰攀登尝试中，1855年，由采尔马特组成的人攀登小组在三个导游带领下，于瑞士国庆日8月1日登顶成功。</p>`
        },
        {
            id: 0,
            month: '2017-11',
            day: '16',
            img: require('./../assets/img/artical/health/01.png'),
            cover: 'static/img/health/news1.png',
            txt: '小镇',
            title: '德国十大特色小镇，你最中意哪一款……',
            desc: '在德国，除了众所周知的景点外，还藏匿着众多特色鲜明的小镇。时间在这些角落里投映的斑驳与历史，总让人流连忘返，忍不住地要去细细品尝与玩味。1、海德堡Heidelberg，我把心遗落在了这里，这里有德国最古老的大学、满目的青山、内卡河的绿水、刻满历史沧桑的古堡残.......',
            content: `<p>在德国，除了众所周知的景点外，还藏匿着众多特色鲜明的小镇。时间在这些角落里投映的斑驳与历史，总让人流连忘返，忍不住地要去细细品尝与玩味。</p>

        <p>1、海德堡Heidelberg，我把心遗落在了这里<br />&emsp;&emsp;我把心遗落在了海德堡。——歌德，这里有德国最古老的大学、满目的青山、内卡河的绿水、刻满历史沧桑的古堡残垣、尖顶错落和石径幽深的老城，所谓童话，不过如是。但是海德堡最美丽的一面，需要在山间小径中散步，在内卡河上泛舟，在老城的小巷里闲逛，放慢节奏与心情，才能真正品味这座诞生了德国浪漫主义的小城。</p>

        <p>2、巴登巴登Baden Baden，难以言传的向往<br />&emsp;&emsp;巴登巴登，一种永远难以言传的向往。——音乐大师勃拉姆斯，巴登巴登位于奥斯河谷中，城市沿着山谷蜿蜒伸展，背靠青山，面朝秀水，景色妩媚多姿，是一座安静的小城。这里气候宜人，被称作“欧洲的夏都”。谷中“巴登巴登”地流过。入夜，四周群山回响，摇你入梦。巴登在德语中是洗澡的意思。</p>

        <p>3、新天鹅堡Schloss Neuschwanstein，童话王国<br />&emsp;&emsp;新天鹅城堡又名“白雪公主城堡”，是座白墙蓝顶的神话城堡，坐落于福森小镇上，阿尔卑斯山脉中。相传国王对骑士传说产生浓厚兴趣，决定将骑士传说等场景在自己的城堡中再现。梦幻的氛围、无数的天鹅图画，加上围绕城堡四周的湖泊、无边的原始森林、柔嫩的山坡、沉沉的湖水、绿野上漫步着的成群牛羊和终年积雪的阿尔卑斯山，美得如诗如画，宛如人间仙境。</p>

        <p>4、梅尔斯堡Meersburg 古堡为身，葡萄酒是魂<br />&emsp;&emsp;德国西南角，博登湖西岸，有座栽种着葡萄的突起丘陵，山顶上有一座建于中世纪时期的古堡，那就是梅尔斯堡。小镇即因古堡和博登湖而得名。蔚蓝的天空，傲然矗立的古堡，清澈的湖水，茂盛的森林，安静的小木屋，艳丽的鲜花，偶尔飞过的轻快小鸟，这些景致浑然天成。在这里漫步，你可以体会到其中的闲情逸致。在一间朝向博登湖的咖啡店，点上一杯啤酒或咖啡，看着湖上悠闲的天鹅，惬意无比。</p>

        <img src="static/img/health/1/1.png" />

        <p>5、帕绍Passau，自然天成的边境古镇<br />&emsp;&emsp;帕绍是一个还未被太多游客注意到的安静小城。它最特别之处，是它“三河之城”别称的由来——处在多瑙河和茵河的交汇口上，并且还有另一条名为伊尔兹的小河汇入。正是这特别的地理景观，给了帕绍独一无二的风情。帕绍的老城就在深入交汇口的一块狭长的三角形半岛上，北岸有一座哈克尔山俯瞰并守卫着它。帕绍的历史悠久，可以追溯到凯尔特人和罗马人时期。旧城曾在一场大火中毁于一旦，重建时赶上了巴洛克最盛行的时期，也就成了如今帕绍老城呈现出来的模样。你可以沿着任意一条河岸漫步；</p>

        <p>6、罗滕堡Rothenburg ob der Tauber，中世纪精华小城<br />&emsp;&emsp;罗滕堡的全称，是陶伯河上的罗滕堡，用以区分其它称作罗滕堡的地方。这是“浪漫之路”和“城堡之路”的交汇点，一个风貌齐全的中世纪童话小镇。罗滕堡出名，在于它是德国中世纪小城中的精华，没有受到战争的摧毁，更在于最近二十年中得到的极力修护。它保存良好的老城，完整地再现了中世纪的风貌。小城里石巷蜿蜒，房子古朴，有连绵的城墙、高耸的塔楼、颠簸的石板路、迷人的花园与陶伯河的流水，还有各种隐身在老房子里的有趣的博物馆和商店，非常美丽而有意境。</p>

        <p>7、纽伦堡Nürnberg，古典而稳重<br />&emsp;&emsp;纽伦堡拥有悠久的历史和传统，曾是神圣罗马帝国的自由城邦，也是非正式的都城，深受德国皇帝的喜爱，在这里留下了许多历史建筑和艺术遗产。<br />&emsp;&emsp;这个城市努力在推动人权的道路上，发挥积极的作用。如今，老城被全力修复，再现了中世纪的风貌。老城有浓重的中世纪特色，非常古典而稳重，北端的皇帝堡是城市的重要标志。从几乎绕城一周的城墙，到德国最重要的画家丢勒的故居，到纽伦堡的传统姜饼与香肠，这座城市终于能再度享受着丰富的历史文化遗产，成为巴伐利亚城镇中，不可忽视的一站。</p>

        <img src="static/img/health/1/2.png" />

        <p>8、班贝格Bamberg，优雅大气<br />&emsp;&emsp;这是一座历史底蕴深厚、风光美丽大气的城市，实在值得细细品味一番。<br />&emsp;&emsp;它因保存良好的历史建筑，赢得了“弗兰肯的罗马”之美誉，被收录在世界文化遗产名录中。莱茵-美茵-多瑙运河和雷格尼茨河并行穿城而过，岛城区是如今班贝格的心脏地带，河上的桥与河岸边的风景，给老城更添几分风情。这里最出名的饮品是传统酿制的啤酒，尤其是烟熏啤酒，在德国众多种类的啤酒中独树一帜，是不可错过的味道。</p>

        <p>9、维尔茨堡Würzburg，巴洛克奢靡<br />&emsp;&emsp;这是一个历史悠久，而又充满生命力的城市。美茵河从维尔茨堡的老城中流过，河上有十五世纪遗留下来的老桥，河边的玛丽安城堡俯瞰着老城，这是维尔茨堡最经典的风景。维尔茨堡官邸是德国最重要的、也是最美丽的巴洛克宫殿之一，世界文化遗产。它外表雍容，内饰华丽，极尽巴洛克奢靡的装饰风格。尤其是巨大的主阶梯顶部，由艺术家Tiepol绘制了一幅迄今为止全世界最大的湿壁画，主题为当时认知的四大洲——欧洲、非洲、美洲和亚洲。</p>

        <p>10、雷根斯堡Regensburg，风韵犹存<br />&emsp;&emsp;这是德国最古老的城市之一，在石器时代就有了人类的活动遗迹。在公元179年，由罗马人建城，至今在雷根斯堡老城仍能见到古罗马遗迹。中世纪是雷根斯堡的辉煌年代，横跨多瑙河的石桥落成，使它成为了地区运输的枢纽，经济发达，有重要的政治地位。雷根斯堡的老城在多瑙河的南岸，这是德国最大的、也是保存较好的中世纪老城，被收录为世界文化遗产。多瑙河边的石桥、教堂和塔楼，是这座城市的风韵。而老城中蜿蜒的小巷，也隐藏着许多的惊喜。</p>`
        }
    ],
    travelArticalId: 0,
    horseArtical: [{
            id: 12,
            month: '2019-01',
            day: '09',
            img: require('./../assets/img/artical/horse/13.png'),
            cover: 'static/img/horse/news13.png',
            txt: '思考',
            title: '对首项世界级纯演示性速度马术的思考',
            desc: `据报道，香港赛马会将于2019年3月23日在从化马场举办首项世界级纯演示性速度马术比赛，这是香港赛马会与广州市从化区政府深化合作的结果，目的是让内地民众也能体验到香港世界极标准的赛马运动。仔细阅读会发现，香港赛马会此轮比赛，将耳熟能详的“速度赛马”替换成了“速度......`,
            content: `<p>据报道，香港赛马会将于2019年3月23日在从化马场举办首项世界级纯演示性速度马术比赛，这是香港赛马会与广州市从化区政府深化合作的结果，目的是让内地民众也能体验到香港世界极标准的赛马运动。</p>

            <p>仔细阅读会发现，香港赛马会此轮比赛，将耳熟能详的“速度赛马”替换成了“速度马术”，究竟是赛事模式的悄然创新，还是现阶段谈到赛马的谨慎过度？背后原因值得深究。</p>

            <img src="static/img/horse/13/1.png" />

            <p>此番“赛马”变“马术”，有两个点需要关注：</p>

            <p>第一，几年来，赛马运动焕发生机，我国马产业的长足发展，为赛马运动的推进提供了良好的基础设施。但在部分群体眼中，赛马的性质、定位与归属难同我国阶段性的政治、经济目标规划相一致。考虑到赛马运动的全局性，与“赛马”相关的诸多企业在注册时就已经遭遇瓶颈，中央会同地方曾多次叫停赛马，这让后来的赛马运动难以开展、谈虎色变。</p>

            <p>第二，虽然马术项目和赛马运动在全国范围内陆续开展，但仍有部分社会民众对赛马和马术的概念混淆不清，这是导致两项运动在大众间难以推广的主要原因。</p>

            <p>不具备招商、可持续发展条件是中央、地方叫停赛马、关停与赛马相关的招商引资的一大因素。“2018年中国（海南）自贸区（港）百日大招商”正式启动，124项重点招商任务表对外公布。海南在获准赛马试点后，企业蜂拥而上，资本聚焦也呈现出无序状态，海南省工商局暂停受理“赛马”等字样的企业注册登记申请。</p>

            <p>回到2002年，据报道，公安部、财政部、国家旅游局和体育总局等五部委联合发文，禁止经营带有博彩性质的赛马活动，使当时国内刚有起色的赛马受到极大影响。同样，成都市“2001年中国国内旅游交易会”期间，关于借“首届中国西部民族马术节”活动大肆赌马的新闻爆出，全国赛马业的发展降至冰点。</p>

            <p>1999年12月，广州赛马场突然叫停，跑了757场次赛马后，历经七年的广州赛马画上句号。“未能合法化”化解了此番叫停的疑问，广州人民对赛马有了感情，但赛马的运作及赛马场的规划利用，却让这份感情蒙上阴影。</p>

            <img src="static/img/horse/13/2.png" />

            <p>严格来说，速度赛马是一项竞技类的运动项目，以马匹奔跑速度和骑手驾驭马匹能力决胜负，考验了骑手的综合水平。</p>

            <p>速度赛马历史悠久，据资料显示，古希腊举行的古代奥林匹克运动会上就有四匹马驾车竞技比赛，40年后，比赛改由骑手驾驭马匹参赛。速度赛马是从选拔优秀马匹的过程引申而来，成绩取决于马的速度、耐力以及父母辈的血统。</p>

            <p>而马术项目则包括场地障碍、盛装舞步和西部马术等。有人形容马术如同舞蹈学习，舞伴很重要，刚开始学习的人需要学会如何用舞蹈式的步伐走路，马就是最好的舞伴。在英国，马术甚至成为一个人身份的代表，深受大众喜爱。</p>

            <p>“马术不是赛马”，上海马术运动管理中心某专业人士这样说。赛马比的是马匹的速度，在规定的距离里，冲过终点的就是冠军。马术更注重选手和马匹之间的配合，优雅和曼妙成为马术的代名词。</p>`
        },
        {
            id: 11,
            month: '2019-01',
            day: '04',
            img: require('./../assets/img/artical/horse/12.png'),
            cover: 'static/img/horse/news12.png',
            txt: '外媒报道',
            title: '法媒：马术在中国不只是一项体育运动',
            desc: `据欧洲时报网1月4日报道，整洁的马靴、高大的马棚、宽阔的围场……这不是英国，而是在中国上海。随着中国经济的发展，马术运动受到了越来越多中国富豪的青睐。法新社报道称，过去的5到10年间，马术运动在中国迅速发展。距离上海两个小时车程的无锡市，伫立着一座包含酒店、画廊......`,
            content: `<p>法新社报道称，过去的5到10年间，马术运动在中国迅速发展。距离上海两个小时车程的无锡市，伫立着一座包含酒店、画廊、购物中心、马术俱乐部和马文化博物馆的主题公园。该公园名为“飞马水城”，这里拥有来自全球各地的400多匹马，每周都举行马车巡游和表演。就像宣传语中写的那样，宏伟的装潢宛如“奥匈帝国的盛景”。</p>

            <p>所有这些能够实现，都是因为中国在20世纪80年代进行了改革，一跃成为世界第二大经济体。</p>

            <p>“40年前，中国非常贫穷，没办法进行这项高雅运动。”公园内一家马术俱乐部经理沈厚峰（Shen Houfeng，音译）说。</p>

            <img src="static/img/horse/12/1.png" />

            <p>法国《解放报》称，如今，中国积累的财富已经能与美国一较高下，新兴富裕阶层也在不断增长。</p>

            <p>富豪们的社交平台</p>

            <p>马术俱乐部在中国起步不久。3年前，留英归国的马术爱好者孙惠琴创立了中国首家以马术及猎狐运动为主题的私人俱乐部--唐郡马术俱乐部（County Down Club）。</p>

            <p>32岁的孙惠琴说：“如今，中国富豪们需要新点子来进行消费，以显示与众不同，马术正符合他们的需求。”</p>

            <p>孙惠琴的俱乐部里有十几匹马和80多名会员，他们每人每年必须支付5.8万元的会费。不过，并不是有钱就万事大吉了。</p>

            <p>“我们的会员应该拥有良好的素质和礼仪，甚至应该是精英知识分子。”孙惠琴说，“因此他们档次相同，可以相互交流。”</p>

            <p>除了十几匹马之外，俱乐部还配备有室内游泳池、健身房和全新的白色钢琴。孙惠琴承认，这些设备和骑马一样重要。</p>

            <p>“我们的优点之一是给会员们创造了相互结识的平台，”他总结道，“因此，他们能够互相帮助，走得更远。”</p>

            <p>至于猎狐，会员们不能在中国进行这项活动。不过，俱乐部和欧洲的一些大家族有联系，他们可以去那里追逐狐狸。</p>

            <img src="static/img/horse/12/2.png" />

            <p>精英教育的育儿法</p>

            <p>“对于中国父母来说，马术是子女精英教育的一部分，能让他们在这个竞争激烈的社会中鹤立鸡群。”法国乐马（Le Cheval）的前任代表覃婷婷说。这个非营利性组织是是法国赛马、马术和马文化在中国的总代表处。</p>

            <p>“对成年人来说，马术也不只是一项运动。它代表了投资、旅游、娱乐、社交……对中国人来说，这是一种全新的体验。”覃婷婷总结道。</p>

            <p>虽然中国马术运动协会没有提供具体数字，不过根据著名的英国马术杂志《马术》（Horsemanship）报道，目前中国共有1800多家马术俱乐部。</p>

            <p>不过，《马术》杂志强调，在中国马术的发展过程中，依然缺乏专家（包括教练和兽医）与展示平台。</p>`
        },
        {
            id: 10,
            month: '2018-12',
            day: '13',
            img: require('./../assets/img/artical/horse/11.png'),
            cover: 'static/img/horse/news11.png',
            txt: '赛事',
            title: '中国马术巡回赛广州总决赛正式启动',
            desc: `12月20日，由中国马术协会主办、中马国际承办的国际马术联合会（FEI）三星级场地障碍赛——浪琴表中国马术巡回赛香港赛马会杯广州总决赛新闻发布会在广州成功举行。伴随着中国马术协会秘书长钟国伟、香港赛马会主任顾问任军、广东省体育局黄村体育训练中心主任蔡建祥、上海市......`,
            content: `<p>12月20日，由中国马术协会主办、中马国际承办的国际马术联合会（FEI）三星级场地障碍赛——浪琴表中国马术巡回赛香港赛马会杯广州总决赛新闻发布会在广州成功举行。伴随着中国马术协会秘书长钟国伟、香港赛马会主任顾问任军、广东省体育局黄村体育训练中心主任蔡建祥、上海市体育局马术运动管理中心主任程克强、中马国际总经理江健和中国马术队成员、广东队骑手梁锐基将金沙缓缓洒向启动台，标志着浪琴表中国马术巡回赛香港赛马会杯广州总决赛正式启动。</p>

            <p>作为2019年在中国举办的首场国际马联星级赛事，浪琴表中国马术巡回赛香港赛马会杯广州总决赛将于2019年1月4日-6日在广东省黄村体育训练中心隆重上演。</p>

            <p>中国马术协会秘书长钟国伟、香港赛马会主任顾问任军、广东省体育局黄村体育训练中心主任蔡建祥、上海市体育局马术运动管理中心主任程克强、内蒙古自治区体育局马术运动管理中心主任范春阳、中国马术协会竞赛部副部长侯天博、香港赛马会国内体育项目助理经理李若、中马国际总经理江健、中国马术队成员、广东队骑手梁锐基及诸多马术领域从业人员、企业代表等出席发布会。</p>

            <img src="static/img/horse/11/1.png" />

            <p>中巡赛见证马术运动发展</p>

            <p>中国马术协会秘书长钟国伟在致辞中表示：“中国马术巡回赛连续举办6年，时至今日，这项赛事见证了中国马术运动的发展。香港赛马会、浪琴表等知名企业的鼎力支持为中国马术巡回赛的发展起到了积极作用，更是助推了中国马术运动的发展。2018年，按照总局‘以备战促改革，以改革强备战’的总思路，中国马术协会积极推进协会实体化改革，并树立了三大目标：冲击奥运奖牌、扩大中国马术运动人口，做大马术市场、有朝一日举办世界顶级马术比赛。围绕这三个目标，协会积极构建竞赛体系、训练体系、人才培养体系、市场体系、会员发展体系五大体系建设。今后，中国马术协会将继续通过一系列接地气、惠民生、聚合力、赢大局的改革举措，激发市场活力，释放改革红利，丰富马术业态、马术活动及文化形式，为广大马术爱好者奉献更精彩的马术赛事，推动中国马术事业发展进入新时代。”</p>

            <img src="static/img/horse/11/2.png" />

            <p>2019年首场星级赛事全新开场</p>

            <p>赛事共设置1.00-1.15米级别挑战赛、1.20-1.30米级别精英赛、1.30-1.40米级别香港赛马会杯冠军赛以及1.40-1.50米级别浪琴表大奖赛以及浪琴表中国马术巡回赛每站赛事的保留节目——广受欢迎的斯巴鲁车马赛。赛事总奖金高达153万元，其中大奖赛（1.40米-1.50米级别）奖金总额105万元、冠军赛（1.30米-1.40米级别）奖金总额30万元、精英赛（1.20米-1.30米级别）奖金总额10万元、挑战赛（1.00米-1.15米级别）奖金总额为5万元、斯巴鲁车马赛奖金总额为3万元。</p>

            <p>作为一项创办于2013年的赛事，同时也是国内唯一“中”字头的国际马联（FEI）赛事，浪琴表中国马术巡回赛在2018年实现了全新升级。2018年8月，在复星集团的支持下，中马国际欧洲联赛在荷兰克隆伯格的德皮尔伯根马术中心、比利时桑托尔公园先后开赛，包括多位备战东京奥运中国马术国家队骑手在内的20名骑手团亮相比赛，这不仅是中国马术首次大规模参加欧洲联赛，也是中国一线骑手首次组队出征欧洲高水平马术赛事，同时也翻开了奥运备战的新篇章。</p>

            <p>同时，为了体现复星布局马上综合运动产业的高品质要求，赛事在2018年9月中旬精选著名地标作为赛事场所，中巡赛首次牵手闻名中外的古关城居庸关长城作为竞技场地，得到了广泛的关注。此外，赛事级别得到提高，此前巡回赛的分站赛事属于国际马联二星级赛事，此次居庸关长城站已成功升级为三星级。</p>

            <p>而即将于2019年1月4-6日举行的浪琴表中国马术巡回赛香港赛马会杯广州总决赛，不仅拉开了2019年在中国举行的国际马联星级赛事的序幕，也是香港赛马会和中国马术协会同策同心携手办赛的第5年。</p>`
        },
        {
            id: 9,
            month: '2018-12',
            day: '07',
            img: require('./../assets/img/artical/horse/10.png'),
            cover: 'static/img/horse/news10.png',
            txt: '常识',
            title: '这些马术小常识你知道多少？',
            desc: `公元前1500年古埃及人已经开始了骑马竞技活动，但是我门现在所熟悉的马术运动的雏形是在16世纪的欧洲出现的，直到18世纪末马术才成为一项独立的运动项目。起源于原始人类的生产劳动过程。公元前680年古代奥运会设有马车比赛。中国的马术也具有悠久的历史，兴于周代，盛于唐......`,
            content: `<p>公元前1500年古埃及人已经开始了骑马竞技活动，但是我门现在所熟悉的马术运动的雏形是在16世纪的欧洲出现的，直到18世纪末马术才成为一项独立的运动项目。</p>

            <p>起源于原始人类的生产劳动过程。公元前680年古代奥运会设有马车比赛。中国的马术也具有悠久的历史，兴于周代，盛于唐代。现代马术运动始于欧洲。古代为了做到战车所用的马匹在战场上移动准确性和精确，常对马匹进行各种技巧和协调性的训练，后来就发展成为马术比赛。1734年美国弗吉尼亚成立查尔列斯顿马术俱乐部，这是世界最早的马术俱乐部。1953年首次举办世界场地障碍马术锦标赛。1966年起举办花样骑术锦标赛</p>

            <img src="static/img/horse/10/1.png" />

            <p>骑马要从基础做起<br />&emsp;&emsp;我发现有的马友对于马匹的装备还不是很熟悉，甚至有些装备的名称还叫不上来，更不要说自己备马了，其实我们出来骑乘都应该从最基础的做起，学会打理马匹：刷马、检查清理马蹄等，还要学会自己给自己备马，这样做有三个好处：1、通过备鞍可以了解马的一些特点（如有的马会鼓肚子等比较油条）通过给马上衔铁可以看看马的牙齿生长状况自己试着去判断一下马的年龄或健康状态（也很有意思哦）。2、备马的同时也是你和马最直接的一个交流，能增近你和马匹之间相互的了解，增加自己骑乘的信心。3、自己备马对于肚带的松紧、马镫长短、马匹受衔情况等都能做到心中有数，可以做到及时检查和扎紧马肚带，合理调整马镫，减少骑乘时的危险。以下是一篇有关马匹装备的帖子，我们可以先试着记住名称，了解作用，然后等到骑马时对号入座，理论联系实际加深印象！</p>

            <p>缰绳<br />&emsp;&emsp;套在马的头上，是骑乘时用来操控马以及与马沟通的工具。一整副缰绳是由顶革、 颊革、额革、咽革、鼻革、手缰与口衔所组成。顾名思义，前面几种革类的部分都是皮革制品，手缰则可由皮革或尼龙等不同材质制成，而口衔则是用金属做的。缰绳应依照马头的大小选用适当尺寸，口衔更是有许多种不同的设计，也各适用于不同的状况与不同的马。如何选择，请务必与您的教练讨论。</p>

            <p>马鞍<br />&emsp;&emsp;马鞍是最重要也是最贵的一个骑乘装备，多为精致的手工皮革制品。英国古典马术使用的马鞍，可分为马术鞍、障碍鞍、与一般骑乘用的综合鞍三种， 设计与形状有一点不太一样。骑手除了因不同目的选用不同的鞍以外，也应依自己的体型选用适当尺寸的鞍。</p>

            <img src="static/img/horse/10/2.png" />

            <p>脚蹬与脚蹬带<br />&emsp;&emsp;挂在马鞍两旁的半圆形金属，就是脚蹬，是骑乘时让骑手双脚踩踏的地方。它也有不同的设计与尺寸，但相较于其它装备，选用不同的设计与尺寸就比较不重要。将脚蹬挂在马鞍上的皮革，就叫脚蹬带。它可依照骑手的腿长，随时调整长度。</p>

            <p>汗垫<br />&emsp;&emsp;汗垫是放在马鞍下面，直接与马背皮毛接触的布垫。它的主要目的，是用来吸收马运动时流的汗水，避免马鞍因汗湿而在马背上滑动。</p>

            <p>鞍垫<br />&emsp;&emsp;骑手骑在马背上时，其体重加上马鞍的重量对马背会造成相当程度的冲击。鞍垫放在马鞍与汗垫之间，可用来平均分配这重量到整个马背，缓冲骑乘时对马背的冲击，避免马背受伤。以前多是用羊毛做的，现在有许多用泡棉或是硅胶做的，效果更好。</p>

            <p>肚带<br />&emsp;&emsp;将肚带两头的扣环系在马鞍，绕过马肚后束紧，可将马鞍固定在马背上。有用皮革做的，也有用尼龙或其它材质做的。马术鞍用的肚带，与障碍鞍及综合鞍用的略有不同。此外，因马的体型大小也应选用适当长度的肚带</p>

            <p>绑腿<br />&emsp;&emsp;当马依照骑手的要求，作各种马术动作时，有时候会不小心踢到自己的脚。为避免马腿受伤，在一般骑乘或练习时，可将绑腿打在马的脚踝关节上方的胫骨处。在障碍超越比赛时，也可以打绑腿，但在马场马术比赛时则不可以打绑腿，以让裁判能看请楚马腿的动作。绑腿的设计与材质可说是五花八门，但其作用不外乎保护马腿。</p>`
        },
        {
            id: 8,
            month: '2018-11',
            day: '14',
            img: require('./../assets/img/artical/horse/09.png'),
            cover: 'static/img/horse/news9.png',
            txt: '贵族运动',
            title: '四大要素告诉你马术为什么是第一贵族运动',
            desc: `马术运动高雅刺激，与3000万美金相应的是赛马的主人亦非富即贵。在英语世界流传着这样一句话：如果年薪20万，你可以玩高尔夫；如果年薪2000万，那你就可以去玩马球。因为，不仅马匹本身十分昂贵，马匹的运输、饲养等环节也繁琐而费钱。于是，昂贵的价格和传承多年的欧洲王室运......`,
            content: `<p>马术运动高雅刺激，与3000万美金相应的是赛马的主人亦非富即贵。在英语世界流传着这样一句话：如果年薪20万，你可以玩高尔夫；如果年薪2000万，那你就可以去玩马球。因为，不仅马匹本身十分昂贵，马匹的运输、饲养等环节也繁琐而费钱。于是，昂贵的价格和传承多年的欧洲王室运动的身份，无疑使马术这项运动打败帆船、赛车等成为第一贵族运动。</p>

            <img src="static/img/horse/9/1.png" />

            <p>第一大要素·亲密</p>

            <p>人们会对自己的工具产生亲密感，一个网球选手会习惯使用某把球拍，爱上自己的幸运球衣，就算一个业余爱好者，也会爱上自己某双合脚的球鞋，丢了熟悉的球包会感到不知所措。即使是这些没有生命的运动设备，也会产生依赖感和亲密感。那么如果是一个鲜活的生命，一个矫健的身影，一个和自己共同驰骋的鲜明的意象，那又会如何？这构建起来的亲密感、骑手和座骑之间的心灵相通，带来的抚慰效应不言而喻。而心理学的研究表明，和动物的亲密感，能有效地抚慰焦躁浮夸的心境，同时能使一个人在看待事物时更加平和全面。而优良的马术骑手，并不是只依赖马童去照顾马匹，经常黎明即起，和马匹建立长期的亲密感，这种亲密感能有效地抚慰心灵。尤其是在现代社会，人与自然疏离，与外部疏离，与生物疏离，马术在锻炼身体的同时，有效地建立起了与其他生灵之间的亲密感。这也许是在草坪上打出一只“小鸟”所无法做到的事情。</p>

            <p>第二大要素·信任</p>

            <p>我们在现代社会失落最多的东西是什么？应该是信任感、瞬息万变波诡云谲人心叵测旦夕祸福，这些使人们对于任何事物都怀抱警惕和防备的心理。然而在马术或更高一级的马球比赛中。全然的信任是有必要的，因为马球队员中如果有不怀好意之辈，就像绿茵场上蓄意冲撞犯规，那么想要让一个人、一匹马栽倒实在是最为轻易不过的事情。因此参与马球比赛的选手，品质极其重要，正因为这些天然接近于绅士品质的品质准入门槛，使得这是一种基于品性全然信任的比赛。在这个过程中人们只需要尽力地去体会和坐骑的配合，和队友的配合，和对手光明磊落地搏击。这种基于全然信任而无防备的竞争性运动，给日常受创的信任感也提供了一个平复的机会。</p>

            <img src="static/img/horse/9/2.png" />

            <p>第三大要素·成就感</p>

            <p>任何运动在掌握了技能以及获得成就之后，都会带来成就感。马术绝对不是能带来成就感的唯一运动，但它一定是能够带来高度成就感的运动。马术本身的古典性的暗示，贵族气质的流露，与动物的亲密接触，被接纳并可以去驾驭，这给心理上带来的成就感非常充分。马术的三项中，盛装舞步一项，仪式感尤为强烈，一旦较为娴熟的掌握，在转移腾挪之间的优美步伐，衣冠磊落的风度呈现，高素质人群的目光投射，都会带来非同一般的成就感。</p>

            <p>第四大要素·舞台</p>

            <p>感除非你是个优秀的专业选手，否则你不大容易在运动场上感到舞台感。投射光速和不断闪动的银光灯就不是为你而生。但马术可不一样，这简直是个天生会产生舞台感的运动。甚至在练习的过程中都是如此。高头大马带来了穿越时空的英雄意识，并且带来了难以比拟的戏剧意识。现代社会对人的一大伤害，就是人们常感到自己是一个大机器上的螺丝钉，很难获得整体意识和独立意识。而在策马奔腾时，你绝对不会觉得自己无足轻重，这样的舞台感安抚了一个自觉渺小的灵魂，使人获得一种良好的自我存在感。</p>`
        },
        {
            id: 7,
            month: '2018-11',
            day: '02',
            img: require('./../assets/img/artical/horse/08.png'),
            cover: 'static/img/horse/news8.png',
            txt: '错误',
            title: '11个骑马常犯的错误，你占了几个？',
            desc: `养成10个坏习惯比改正一个错误动作要容易的多，以下是骑手最容易犯的错误，你中了几个？请教练或朋友帮忙拍下自己骑马的视频，不当的姿势对骑行技术是很大的影响哦`,
            content: `<p class="tac">养成10个坏习惯比改正一个错误动作要容易的多，以下是骑手最容易犯的错误，你中了几个？请教练或朋友帮忙拍下自己骑马的视频然后观看纠正，不当的姿势对骑行技术是很大的影响哦</p>

            <p class="tac">1、松弛的钢琴手——骑马者用钢琴的手握住缰绳</p>

            <p class="tac">2、圆肩——双肩前耸没有打开</p>

            <p class="tac">3、向前倾斜——人骑马向前倾难以保持平衡</p>

            <p class="tac">4、足跟上提——脚跟上提使你小腿僵硬，晃动难以施加腿辅助</p>

            <p class="tac">5、僵硬的或沉重的手——手一直在和马打架，用手在找平衡</p>

            <img src="static/img/horse/8/1.png" />

            <p class="tac">6、向下看——你很难走出直线，马不知道你要去的方向，而且导致骑姿被破坏</p>

            <p class="tac">7、转弯时内倾——导致你和马都失去平衡，圈越来越小</p>

            <p class="tac">8、像坐椅子一样的坐姿——腿在前，耳朵，肩，胯和脚后跟不在一条垂直线，导致起坐时身体和腿晃动，影响平衡</p>

            <p class="tac">9、塌背——身体过分僵直，后背僵硬塌陷</p>

            <p class="tac">10、膝盖夹紧——影响腿辅助，不能深坐在鞍子中，人飘在马上</p>

            <p class="tac">11、僵硬肘部——限制马的动作同时影响你的平衡</p>`
        },
        {
            id: 6,
            month: '2018-10',
            day: '11',
            img: require('./../assets/img/artical/horse/07.png'),
            cover: 'static/img/horse/news7.png',
            txt: '历史',
            title: '马术的发展历史你知道多少？',
            desc: `马在历史上与人类有非常亲密的关系，是人类的运输和交通工具。当中，马在欧洲有贵族的象征，骑马对欧洲人而言不但是一种艺术:最高极致、结合了骑师与马匹之间的调教，更是一门学问。马术比赛需要骑师和马匹配合默契，考验马匹技巧、速度、耐力和跨越障碍的能力......`,
            content: `<p>马在历史上与人类有非常亲密的关系，是人类的运输和交通工具。当中，马在欧洲有贵族的象征，骑马对欧洲人而言不但是一种艺术:最高极致、结合了骑师与马匹之间的调教，更是一门学问。马术比赛需要骑师和马匹配合默契，考验马匹技巧、速度、耐力和跨越障碍的能力。</p>

            <p>1734年，美国弗吉尼亚成立查尔列斯顿马术俱乐部，这是世界最早的马术俱乐部。</p>

            <p>1896年，在希腊雅典举行首届现代奥运会时WINSTON.DEARSUN(温斯顿.迪尔晟)提出将马术列为比赛项目，但是由于组织工作难度较大和主办国希腊对该项目缺乏兴趣而未果。</p>

            <p>1900年，马术比赛首次进入奥运会，当时只设障碍赛一个项目。在巴黎举办了第1次马术国际比赛后，马术运动发展很快。</p>

            <img src="static/img/horse/7/1.png" />

            <p>1906年，以冯罗森(Clarence von Rosen)伯爵为首的一些瑞典军官向顾拜旦提出马术进入奥运会的建议，并受顾拜旦的委托起草了具体的比赛方案。</p>

            <p>1907年，在海牙举行的奥林匹克代表大会通过了该方案，拟在1908年的伦敦奥运会纳入马术比赛。但是伦敦奥运会组委会未执行该决议。直到1912年在瑞典斯德哥尔摩举行第5届奥运会时，马术才进入奥林匹克赛场，</p>

            <p>10个国家的62名马术选手(均为军官)进行了首届奥林匹克马术角逐。</p>

            <p>1912年，第五届的斯德哥尔摩奥运增加了个人和团体赛马、个人和团体军官式骑术以及盛装舞步个人骑术五个项目。现时，奥运的马术项目中包括了三日赛、盛装舞步和障碍赛三个项目，又分为个人和团体赛。</p>

            <p>1952年起，女骑师被允许参加奥运会的马术比赛，马术也成为奥运会中唯一一个男女同场竞技的比赛项目。1953年首次举办世界场地障碍马术锦标赛。</p>

            <p>1966年，起举办花样骑术锦标赛。作为一个团队，马匹和选手将共同获得奖牌和名次。</p>

            <p>2005年7月，国际奥委会第117次全会决定:2008年奥运会马术比赛已在香港举行。</p>`
        },
        {
            id: 5,
            month: '2018-09',
            day: '28',
            img: require('./../assets/img/artical/horse/06.png'),
            cover: 'static/img/horse/news6.png',
            txt: '野骑',
            title: '【野骑】危险行为TOP榜',
            desc: `和开车一样，十祸九快，可见速度给人带来精神和视觉刺激的同时，也给每位骑乘人员带来了危险。速度快时，如果有特殊情况发生，马匹和骑手可能会没有时间反应而发生意外，而且骑手心里一紧张，对马匹的指令会变得乱而不清晰，马匹也会跟着乱。在了解野骑路线路况的情况下、或......`,
            content: `<p>狂奔<br />&emsp;&emsp;和开车一样，十祸九快，可见速度给人带来精神和视觉刺激的同时，也给每位骑乘人员带来了危险。速度快时，如果有特殊情况发生，马匹和骑手可能会没有时间反应而发生意外，而且骑手心里一紧张，对马匹的指令会变得乱而不清晰，马匹也会跟着乱。在了解野骑路线路况的情况下、或有人带领时，可以选择在安全的地方跑一跑。</p>

            <p>不带头盔<br />&emsp;&emsp;很多骑手外出野骑都不喜欢戴头盔，认为自己摔到头的几率很小，而且还能拍到头发飞舞美美哒的照片。其实，没有人能保证不摔马，人只有一个头还是应该保护好它。就和开车系安全带一样，不怕一万就怕万一。</p>

            <p>骑马不专心<br />&emsp;&emsp;出门野骑，我们都喜欢一边骑马，一边聊聊天，这个本无可厚非，即便是聊天你也要注意你马匹的状态以及周边环境的变化，野外环境多变，说不定在你无意的时候，就会有一只狗或者鸟之类的东西出现，马对这些突然出现的东西也会很害怕，常常会做出一些你意想不到的行为，而危险也就在这个时候出现。</p>

            <p>对马体力的自信<br />&emsp;&emsp;长途的穿越，对人对马的体力要求都比较高。每匹马每个人的体力都有差别。在骑上不熟悉的马时最好问问其他熟悉它的人，对马的体力有一个基本的了解。跑跑停停是比较科学的选择，让马和自己都适当的休息一下。</p>

            <img src="static/img/horse/6/1.png" />

            <p>骑马扎堆，遛马扎堆<br />&emsp;&emsp;扎堆是非常危险的，首先靠得过紧难免会有擦擦碰碰的，万一谁的衣服勾到谁的背包拉链上就不太好了，严重的还可能导致摔马；其次马儿的心情难料，说不定它就不喜欢自己身边那匹马，转身就踢一下咬一口的，无论是场地骑乘还是外出野骑，都应该保持科学的安全距离。</p>

            <p>过于自信<br />&emsp;&emsp;骑手应该对自己骑术水平有一个客观的定位，不要过于自信。骑自己能骑住的马，跑自己能控制住的速度，不要逞强而造成自己、马匹和他人的危险。</p>

            <p>不注意检查马匹装备<br />&emsp;&emsp;每隔一段时间就要检查自己的马匹的肚带，上马前、骑一小段时间后、休息时等，总之，勤检查鞍具没有坏处。</p>

            <p>尽量避免：穿梭树林<br />&emsp;&emsp;在树林中穿梭，对于一个骑手来说也是很危险，即使你是一个老手。你也不会知道下一棵树长什么样，如果刚好有一棵树横着伸出一个树干，而你又无法躲开它，那么你所能做的只有弃马而去！幸运的话你只会摔到屁股。要是这些天你不够走运，破相在所难免！</p>

            <p>尽量避免：柏油路、冰面<br />&emsp;&emsp;这个就不用说了，坛子里的前辈已经尝试过，马会在水泥地面等坚硬的场地上打滑。在冰面上也是很危险的，马佩戴金属的蹄铁，雪接触到金属物质会加速融化，同时又吸收了从马蹄而来的热量，融化成的雪水向下流到蹄铁处，与冰冷的雪地接触迅速结冰，使得蹄铁就像溜冰鞋一样滑。塑料的雪地靴可以隔离雪与蹄铁的接触，减少马匹滑倒的概率。</p>`
        },
        {
            id: 4,
            month: '2018-09',
            day: '17',
            img: require('./../assets/img/artical/horse/05.png'),
            cover: 'static/img/horse/news5.png',
            txt: '运动会',
            title: '世界马术运动会：中国耐力赛军团表现可圈可点',
            desc: `尽管如此，这次比赛对于中国马术耐力赛仍然意义非凡。这是中国队第一次派出由四位骑手组成的团队参赛。虽然比赛因为极端天气中止，但中国骑手不但在对马匹福利的理解上，显示出了世界级的素养；还在极端天气的比赛中，展示出了世界级的实力。`,
            content: `<p>尽管如此，这次比赛对于中国马术耐力赛仍然意义非凡。这是中国队第一次派出由四位骑手组成的团队参赛。虽然比赛因为极端天气中止，但中国骑手不但在对马匹福利的理解上，显示出了世界级的素养；还在极端天气的比赛中，展示出了世界级的实力。</p>

            <p>四位中国耐力赛骑手赛后并没有显得愤愤不平或者垂头丧气。几位骑手说，失望之情当然难以避免，但是出战前和比赛后，中国马协都与骑手们有深入的交流，各位骑手愿意理解和支持国际马联做出的决定。</p>

            <p>本次代表中国队出战世界马术运动会的一共有五位骑手，除了华天参加三项赛，其他四位贾惠林、隋博、成昭毅和王志强都是耐力赛骑手。中国现在有十几位耐力赛骑手有望获得资格，这四位骑手用了近两年在世界各地参赛，因积分最高获得了参赛资格。虽然比赛最终因为极端天气而中止，但是隋博和王志强两位骑手在暴风雨中完成了近115公里的赛道，在119对人马组合被淘汰了70余对的情况下，顺利通过了第三程的验马，始终未被淘汰，而且有望冲击名次。</p>

            <img src="static/img/horse/5/1.png" />

            <p>说到当天的比赛，王志强说，“这次比赛的确实比较困难，第一就是赛道上山与下山比较多，并且直路很少，加上下雨难度就更大了。第二环境湿度比较大，运动员在比赛过程中真的可以说是挥汗如雨，呼吸特别困难，更别说马了，这样的环境对于马的心肺功能更是一种挑战。”隋博也有类似的感受，“在比赛中最困难的就是第二程，当时雨特别大，本来起伏很大的道路又变得特别湿滑，暴雨给马匹的肩部和腿部造成了非常大冲击。”</p>

            <p>几位骑手中，只有贾惠林还参加过2014年法国诺曼底世界马术运动会，当天他的马顺利通过验马，但是他在开赛前15分钟，出于对自己马匹健康的考虑，决定主动退赛。他表示，通过这几年的努力，国际马联的耐力赛在中国的认可度越来越高。中国人越来越多地参与到国际马联的顶级赛事中，对骑手的经验积累会有很大帮助。</p>

            <p>骑手成昭毅虽然也因为马匹状况未能参赛，但在谈及世界马术运动会的意义时，他表示，“我也参加过2016年的耐力世锦赛，我认为这些都不仅仅是比赛，也是一种马文化的传播，以及中国骑士精神的展现。对目前阶段我觉得无所谓胜负，这种文化的传播才是最重要和最深远的。”“我们这些走出国门的骑手要利用这些更大的平台扩大这项运动的影响力，把国际上好的赛事、好的训练方式引进来。”</p>

            <p>四名骑手之中，有好几位都是因为对耐力赛的喜爱，积极锻炼身体、增加肌肉、减轻体重，于是获得比赛荣誉的故事，同时也是自我管理的励志故事。隋博表示，自己骑马后体重减了近50斤，现在天天锻炼身体，尤其是与马匹较为贴近的肌肉，比如说腹肌、腿部和腰部的肌肉，都会着重练习，这样才能和马匹完美配合。王志强也是通过每周三次跑步五公里，降低体重，储备体能。</p>
            
            <p>此外，几位骑手都提到了耐力赛对于自身毅力的考验。隋博讲述了自己为了获得积分，挑战极限在三天内完成340公里赛程的传奇经历。贾惠林表示，耐力赛虽看似入门简单，但是想要提高水平，就需要经过非常艰苦的训练。王志强认为，成为一名优秀耐力赛骑手需要诸多要素，但最重要的就是坚强的意志和不屈不挠的精神。</p>`
        },
        {
            id: 3,
            month: '2018-08',
            day: '30',
            img: require('./../assets/img/artical/horse/04.png'),
            cover: 'static/img/horse/news4.png',
            txt: '合作',
            title: '从化马场正式开幕 为粤港深化马产业合作奠定基础',
            desc: `香港赛马会从化马场2018年8月28日正式开幕，标志着香港赛马及粤港合作迈进新里程。马会今天在从化马场举行开幕典礼，超过500名嘉宾出席庆祝这项盛事，当中包括内地及香港特别行政区政府官员、马会会员、练马师、骑师及项目工作伙伴。`,
            content: `<p>香港赛马会从化马场2018年8月28日正式开幕，标志着香港赛马及粤港合作迈进新里程。马会今天在从化马场举行开幕典礼，超过500名嘉宾出席庆祝这项盛事，当中包括内地及香港特别行政区政府官员、马会会员、练马师、骑师及项目工作伙伴。</p>

            <p>位于广东省广州市从化区的从化马场是内地首个世界级马场和纯种马训练中心，在两地双向营运模式下，与沙田现有的训练中心相辅相成地运作。从化马场顶尖的马匹训练及护理设施将有助马会进一步提升世界级赛马运动的水平。</p>

            <img src="static/img/horse/4/1.png" />

            <p>马会主席叶锡安博士表示：‘香港赛马会是全球赛马运动的领导机构，赛驹中包括全球其中一些最顶尖的马匹。从化马场拥有优秀的马匹训练及护理设施，包括内地首间世界级马医院；加上从化区高水准的生态环境、空气和水质都非常优良，实在是训练马匹最理想的地方。’从化马场的落成及其营运安排，是马会与中央政府、广东省、广州市、深圳市及香港特区政府之间紧密合作的成果。叶博士说：‘从化马场是一项重大的成就。马会衷心感谢中央政府、广东省及香港特区政府的支持，以及各级政策局、部门和检测机关，为从化马场所作出的重大贡献。’</p>

            <p>从化马场身处内地唯一的大型国际认可无规定马属动物疫病区内，能确保香港赛驹不论在从化或香港，其健康状况均获确认为相同，这对马场的运作极为重要。透过内地政府与香港特区政府之间所订立的一系列特别安排，马匹可以顺利往返从化与香港。马会行政总裁应家柏先生表示：‘从化马场拥有来自香港、从事不同专业领域的资深员工，包括赛事营运、跑道、兽医和马房等。他们会跟在内地招聘，并接受在香港设计及获国际认可的培训计划训练的本地员工，共同为马匹提供与香港水平相同的专业护理。’</p>

            <p>广州市人大常委会主任陈建华先生和香港特区食物及卫生局局长陈肇始教授也在开幕典礼上致辞。</p>

            <img src="static/img/horse/4/2.png" />

            <p>广州市人大常委会主任陈建华致辞，表示从化马场的开幕为广州与香港深化马产业合作奠定了坚实的基础。陈建华主任表示：‘今天，呈现在我们眼前的俨然是一座现代化、高科技、世界一流的赛马场和国内规模最大、标准最高的世界级马匹运动训练中心。’‘从化马场的开幕，更为广州与香港深化马产业合作奠定了坚实的基础、打开了想像的空间，展示了美好的发展前景。’陈主任说：‘广州将与香港特区政府、香港赛马会一道，密切政策协调，深化务实合作，全力保障香港赛马会从化马场的运营和发展。’陈肇始局长表示：‘内地与特区彼此优势互补，结合了内地的基建设施、特区政府在马病检疫上的经验，还有香港赛马会在赛马运动方面的专业知识，成功建立了从化马场。 ’</p>

            <p>展望未来，从化马场具潜力支援粤港澳大湾区和整个内地马术产业的发展。叶博士表示：‘在世界各地，马术产业能为经济和就业带来重大贡献，在从化也不会例外。马会定当运用我们世界级的专业知识和人才，提供全面支援。’</p>`
        },
        {
            id: 2,
            month: '2018-05',
            day: '08',
            img: require('./../assets/img/artical/horse/03.png'),
            cover: 'static/img/horse/news3.png',
            txt: '规则',
            title: '科普：马术障碍赛观赛指南 一分钟看懂罚分规则',
            desc: `场地障碍是马术运动的项目之一，骑手和马匹通力合作在限制时间内共同跨越所设定路线内的10—12道障碍。这项运动要求骑手和马匹勇敢、准确并且坚毅，他们共同的目标是在尽量短的时间内准确无误而快速地跨越全程障碍。`,
            content: `<p>场地障碍是马术运动的项目之一，骑手和马匹通力合作在限制时间内共同跨越所设定路线内的10—12道障碍。这项运动要求骑手和马匹勇敢、准确并且坚毅，他们共同的目标是在尽量短的时间内准确无误而快速地跨越全程障碍。</p>

            <img src="static/img/horse/3/1.png" />

            <p>马术项目竞赛种类繁多，奥运会马术比赛只设场地障碍、盛装舞步和三日赛三个项目。比赛要求在长90米、宽60米的场地内进行。行进的路线长度要求450到650米之间，共设置12道各种式样、形状的障碍，其中一道为双重障碍，一道为三重障碍。障碍前放置 1-12的号码，标志骑手要按号码顺序依次跳完全部障碍。</p>

            <p>障碍高度共分三个难易级别，最低为C级，1.2米高；其次为B级，高度在1.2米-1.4米之间，一般仅设置数道1.4米高的障碍；最高为A级，高1.6米。</p>

            <p>骑手进入场地后，裁判长示铃比赛开始，骑手须在60秒钟内通过起点（D）标志杆，方可进行比赛。12道障碍全部跳完后，必须通过终点（A）标志杆，比赛成绩方可有效。骑手通过每一道障碍的正确方向是白旗在左侧，红旗在右侧。</p>

            <img src="static/img/horse/3/2.png" />

            <p>马术比赛分为团体赛和个人赛，团体赛每队4名选手组成，将其中前3名队员的成绩相加为团体成绩。个人赛的障碍高度高于团体赛，骑手出现罚分相同，将进行复赛。</p>

            <p>罚分规则<br />&emsp;&emsp;骑手在比赛中，每打落一个横杆，罚4分；马匹在障碍前不跳或者不服从骑手的控制，罚3分；超过规定时间，每秒钟扣罚 0.25分；骑手第一次落马、罚8分；骑手没有按号码顺序跳障碍、第二次落马、或者全场比赛马匹共计3次不服从以及超过比赛的限制时间，选手将被淘汰出比赛。场地障碍赛的成绩评定以障碍罚分少、时间快为比赛的优胜者。</p>`
        },
        {
            id: 1,
            month: '2018-04',
            day: '13',
            img: require('./../assets/img/artical/horse/02.png'),
            cover: 'static/img/horse/news2.png',
            txt: '穿衣',
            title: '给马穿衣有讲究！如何为爱马挑选一件合身衣服',
            desc: `说到马衣，很多人会认为这专业骑手的事情。其实不然，不一定只是专业骑手的马才能选择马衣，任何纯血马和温血马或者只要拥有马的人士均可选择适合不同季节的马衣。马衣是因为纯血马和温血马的存在而发展起来的一种必需品。又因为马的体毛影响，马在奔跑时通过皮肤会出汗引起皮......`,
            content: `<p>说到马衣，很多人会认为这专业骑手的事情。其实不然，不一定只是专业骑手的马才能选择马衣，任何纯血马和温血马或者只要拥有马的人士均可选择适合不同季节的马衣。</p>

            <p>马衣是因为纯血马和温血马的存在而发展起来的一种必需品。又因为马的体毛影响，马在奔跑时通过皮肤会出汗引起皮肤病，故马自幼年起就被马主剃除体毛；还有大自然天气变化等等因素，使得马主不得不根据季节需求选择一件合适的马衣来保护马匹。</p>

            <p>随着马匹的进化和用途推广，马衣的选择越来越严格，需求也越来越大。因此选择一件合适的的马衣穿戴在马身上是必然的事情。</p>

            <img src="static/img/horse/2/1.png" />

            <p>根据季节挑选马衣<br />&emsp;&emsp;根据季节和天气情况选择适当的马衣。如夏季以轻薄透气材质的马衣为主，选择带网孔的马衣穿在马身上以防止蚊虫叮咬。首先马的头部要使用网纱头套将其盖住避免蚊虫叮咬影响马的情绪；另外穿上带有网孔的马衣，马的身体部分也可以拒绝蚊虫叮咬，避免登革热病和其他类似人类被蚊虫叮咬的皮肤病。所以在夏天穿戴带有网孔的马衣是十分必要的，尤其在马棚内或户外运动时，这种网孔马衣尤为重要。</p>

            <p>还有在夏天温差较大的地区或者春夏、夏秋交叉季节，适合选择轻薄型马衣。如有一种带吸汗的轻型马衣在夏天温差较大的地区用途很广。在温差较大的地区，夏天的晚上天气会变凉，这种轻薄型的马衣穿戴尤为重要，它可以避免因天气变化大而引起马感冒发热等病状。春夏、夏秋之季给马选择穿戴轻薄型马衣也是一种理想选择，这种马衣对马在马棚或户外运动都都很重要。</p>

            <p>冬天选择好棉马衣是为马的保暖提供保障，要根据不同地区的天气温度进行选择。如北方天气特别冷的情况下，一般要选择较厚的棉马衣才能抵御寒冬；南方天气在冬天时稍微温暖，故选择较薄的棉马衣就可以过冬。也就是要根据不同地区的不同温度来选择和穿戴棉马衣。</p>

            <img src="static/img/horse/2/2.png" />

            <p>功能马衣与尺寸的选择<br />&emsp;&emsp;有一种功能性的马衣在当今世界十分流行，是随马事业发展而产生的一种新型产品。大家知道马的体征和人类一样都是怕冷又怕热的排汗型动物，因此穿戴有功能性的马衣是十分理想的。特别马是一种剧烈运动型的动物，它在奔跑之后会出汗，故气候寒冷时容易引起感冒。所以夏季当马在运动奔跑后出汗时、或者淋浴后，都要即时给马穿上轻薄吸汗的马衣。冬天马在户外跑动时穿上带有吸汗功能的棉马衣会使马的身体得到保暖。</p>

            <p>最后，马衣的尺寸选择也很重要。选择适当尺寸的马衣对马的舒适和安危起着一定的保护作用。一般马衣尺寸是选小不选大，穿戴合适就行。马主在选择马衣尺寸之前必须量好自己的马体长，前胸量到后尾凸出部分为正确尺寸，并告知给供应商准确的体长，这样选择适当尺寸的马衣才使马感到舒适。因此，在与马相处的过程中，懂得如何挑选一件适合自己马匹的马衣对马主或专业人士而言是一件十分必要的工作。</p>`
        },
        {
            id: 0,
            month: '2018-03',
            day: '25',
            img: require('./../assets/img/artical/horse/01.png'),
            cover: 'static/img/horse/news1.png',
            txt: '马的眼睛',
            title: '关于马的眼睛你可能不知道的5件事',
            desc: `夏天光线非常刺眼，人眼要眯着才会感觉舒服，但强烈的光线好像对马没有任何影响。它们是如何做到的？如果你仔细观察，会发现马的瞳孔上方有一团云状的东西，看着好像是马的眼睛出现了问题，这个东西叫做“黑体”。当光线很强时，黑体可以......`,
            content: `<p>作为有着大眼睛、双眼皮、长睫毛、大长腿，很美的马，它们的眼睛一直都给人留下深刻的印象，让人忍不住多看几眼。但关于这双大眼睛，以下5件事，你可能并不知道。</p>

            <p>1、马眼自带太阳镜<br />&emsp;&emsp;夏天光线非常刺眼，人眼要眯着才会感觉舒服，但强烈的光线好像对马没有任何影响。它们是如何做到的？<br />&emsp;&emsp;如果你仔细观察，会发现马的瞳孔上方有一团云状的东西，看着好像是马的眼睛出现了问题，这个东西叫做“黑体”。当光线很强时，黑体可以遮挡部分瞳孔，减少瞳孔的进光量，这样就不会刺眼了，于是有人戏称黑体是马的太阳镜或者太阳帽。同时扁长的瞳孔，长长的睫毛也减少了上方和下方的光线进入，使阳光不刺眼。<br />&emsp;&emsp;但如果黑体异常的大，而且影响了马的视觉，这个时候就需要找马医来看了。</p>

            <p>2、夜里，光照马眼会发光<br />&emsp;&emsp;夜里用手电照马的眼睛，会发现马眼非常亮，好像在发光一下。这是为什么呢？<br />&emsp;&emsp;因为在视网膜的后面，有一层金属光泽的照膜，照膜可以将光重新反射回视网膜，这样夜间视觉会更好。所以夜间光照在马眼上，马眼会特别亮，好像会发光。不光是马，犬、猫、牛等很多动物也有照膜，所以它们的眼也会发光，而人类则没有，这是我们的夜间视觉没有这些动物好的一个原因。</p>

            <img src="static/img/horse/1/1.png" />

            <p>3、光强变化适应速度慢<br />&emsp;&emsp;马的视网膜上有大量的视杆细胞，这种细胞对光线敏感，这是马夜间视觉好的另外一个原因。但夜间视觉好，意味着他们对光线敏感，因此光线强弱的变化对马刺激明显，需要调整的时间长。<br />&emsp;&emsp;就如开车从隧道里出来瞬间，人眼会很不舒服，甚至会有短暂失明。当马从暗处进入明处，或明处进入暗处，马会停一下，让眼睛调整过来。如果光的强变化太大，马甚至会抗拒。所以当马拒绝进入马厩或运马车时，需要注意一下，是否光的强度变化太大，给它一点时间。

            <p>4、距离感差<br />&emsp;&emsp;众所周知，马的两眼距离较长，使得马的视野可以达到300°左右。但两眼的距离长，也有一个副作用，就是双眼视觉区域比较窄，单眼视觉区域非常大。两眼从两个不同的方向看到同一物体，大脑经过综合，就对物体进行了定位，这样就可以判断距离，所以双眼视觉可以判断距离。<br />&emsp;&emsp;小时候做过一个游戏，闭上一个眼睛，让2个手指从远处逐渐靠近，两个手指很难碰到一起，就是因为单眼视觉难以判断距离。马的双眼视觉区域小，所以马距离感比较差。</p>

            <p>5、马眼受伤后常是蓝色的<br />&emsp;&emsp;很多时候，并不是一定会这样，受伤的马眼睛会变成蓝色。因为这些情况下，受伤的眼睛出现了角膜肿胀，角膜正常状况下是透明的，但当肿胀的角膜清晰度降低，会呈蓝色。如果你发现你的爱马眼睛变成了蓝色的，赶紧报告马医吧。</p>`
        },
    ],
    horseArticalId: 0,
    medicalArtical: [{
            id: 12,
            month: '2019-01',
            day: '22',
            img: require('./../assets/img/artical/medical/13.png'),
            cover: 'static/img/medical/news13.png',
            title: `血液细胞可彻底转化为脑细胞`,
            desc: `科幻的变种人或超级英雄离我们遥远么？相信在不久的将来这些都将成为真实的存在，因为科学家最近发现了一种将免疫系统细胞转化为神经元的方法，人体血液免疫细胞与大脑神经元细胞是两种完全不同的细胞，在形状和功能等方面存在巨大差异......`,
            content: `<p class="tac">科幻的变种人或超级英雄离我们遥远么？相信在不久的将来这些都将成为真实的存在。</p>

            <p class="tac">因为科学家最近发现了一种将免疫系统细胞转化为神经元的方法。</p>

            <p class="tac">人体血液免疫细胞与大脑神经元细胞是两种完全不同的细胞，在形状和功能等方面存在巨大差异</p>

            <p class="tac">然而，《美国国家科学院院刊》刊登的一项新研究发现，血液细胞可以转化为脑细胞。</p>
            
            <img src="static/img/medical/13/1.png" />

            <p class="tac">美国斯坦福大学医学院病理学系副教授马瑞斯·沃尼格博士及其研究小组将T细胞作为研究焦点。</p>

            <p class="tac">T细胞是在免疫系统中破坏病原体方面发挥重要作用的白细胞。</p>

            <p class="tac">增加四种蛋白质后利用“转化分化技术”，T细胞可以在短时间内转化为患者自身的神经元。</p>

            <p class="tac">沃尼格博士表示，将T细胞成功转化为功能正常的神经元只需短短几天时间。</p>

            <p class="tac">T细胞是形态为圆形的特殊免疫细胞，而神经元则带有细长的尾巴，实现T细胞向神经元的成功转化确实有些难以置信。</p>

            <img src="static/img/medical/13/2.png" />

            <p class="tac">这项细胞转化技术将有助于通过血液样本研究病人大脑，尤其是可用来研究精神分裂症和自闭症患者的神经元。</p>

            <p class="tac">以便更好地理解这些疾病的根源，找到可能的治愈良方。</p>

            <p class="tac">不过，新研究也发现，经转化的神经元未能形成细胞相互交流所必需的成熟突触（神经元之间的空间）。</p>

            <img src="static/img/medical/13/3.png" />

            <p class="tac">对此，沃尼格博士表示，下一步的研究目标是改进和完善这项细胞转化技术。</p>

            <p class="tac">目前，研究团队已经开始收集自闭症患儿的血液样本。</p>

            <p class="tac">相信这项技术将会在不久的将来造福全人类！</p>`
        },
        {
            id: 11,
            month: '2018-12',
            day: '11',
            img: require('./../assets/img/artical/medical/12.png'),
            cover: 'static/img/medical/news12.png',
            title: `致胎儿缺陷的“染色体秘密”揭开`,
            desc: `“染色体非整倍性”是导致人类不孕不育、流产、胚胎停育及胎儿缺陷的主要原因，为什么会出现“非整倍性”？多年来世界各地的研究者提出各种各样的解释，但都没有揭示出问题根源。近日，山东大学张亮然教授团队与哈佛大学Nancy Kleckner院士团队合作，首次就该疑问提出了突破性解释。`,
            content: `<p>“染色体非整倍性”是导致人类不孕不育、流产、胚胎停育及胎儿缺陷的主要原因，为什么会出现“非整倍性”？多年来世界各地的研究者提出各种各样的解释，但都没有揭示出问题根源。近日，山东大学张亮然教授团队与哈佛大学Nancy Kleckner院士团队合作，首次就该疑问提出了突破性解释。</p>

            <img src="static/img/medical/12/1.png" />

            <p>据了解，染色体非整倍性属于基因失衡，由一个或多个染色体丢失或增加所致。在非癌性疾病中，最常见的非整倍性是唐氏综合征(先天愚症)。患儿因遗传而获得三条21号染色体，而不是正常的二条。这样，多余的基因信息则导致患儿的发育异常和神经系统异常。</p>

            <p>张亮然告诉科技日报记者，人类胚胎染色体非整倍体发生的概率约为10%，但这一概率随着女性生育年龄的增加而呈指数增长，在女性生育年龄的晚期甚至会超过50%。大多数胚胎非整倍体来源于女性减数分裂染色体的错误分离。这是业界首次对“染色体非整倍性”提出“女性视角”。</p>

            <img src="static/img/medical/12/2.png" />

            <p>张亮然团队与Kleckner院士团队合作对男性和女性生殖细胞的减数分裂重组进行了系统的分析和比较，详细阐述了减数分裂重组在两性之间的差异，并揭示了导致胚胎非整倍体的根本原因。该研究首次发现，染色体重组在两性生殖细胞减数分裂的大部分过程中都很相似，但在女性中有大约25%的重组中间体不能形成真正的交叉重组，造成“交叉成熟缺陷”，正是由于这种女性特有的“交叉成熟缺陷”造成了高频率的染色体分离错误，最终导致了高频率的非整倍体胚胎的产生。</p>`
        },
        {
            id: 10,
            month: '2018-12',
            day: '08',
            img: require('./../assets/img/artical/medical/11.png'),
            cover: 'static/img/medical/news11.png',
            title: `失忆期间施加电刺激有助恢复记忆`,
            desc: `宾夕法尼亚大学的研究小组首次证明，不同时机施加电刺激对人类大脑的记忆功能有不同的作用，记忆失效期施加电刺激有助于恢复记忆，而同样的电刺激，施加于记忆有效期则起到相反的作用。该研究成果发表于出版的《当代生物学》杂志上。`,
            content: `<p>宾夕法尼亚大学的研究小组首次证明，不同时机施加电刺激对人类大脑的记忆功能有不同的作用，记忆失效期施加电刺激有助于恢复记忆，而同样的电刺激，施加于记忆有效期则起到相反的作用。该研究成果发表于近期出版的《当代生物学》杂志上。</p>

            <p>恢复记忆是美国国防高级研究计划局（DARPA）为期四年的研究项目，旨在开发新技术，以改善记忆丧失患者的记忆功能。新研究表明，在适当时机对脑部施加刺激，才能取得较好的治疗效果，在记忆恢复研究上迈出了重要的一步。</p>

            <img src="static/img/medical/11/1.png" />

            <p>研究人员将电极植入到患者脑中，测量大脑各部位的电信号，记录大脑在形成记忆或记忆失败时的不同活动模式，并利用机器学习来解密记忆强弱的电信号，进而识别出大脑有效记忆和无效记忆的神经活动模式。</p>

            <p>利用该模式，研究人员要求受试者在接受安全范围的脑刺激时，学习和回忆常用单词表，来测量在有效记忆期和无效记忆期，电刺激对记忆功能的影响。结果发现，在有效记忆期施加电刺激，记忆变坏。</p>

            <p>在无效记忆期施加电刺激，记忆会得到显著提高。研究人员认为，人类大脑与交通有相似之处，而电刺激可以起到类似恢复交通正常秩序的作用。</p>

            <p>研究人员表示，深刻理解大脑的这一过程，可提高多种类型患者，尤其是那些创伤性脑损伤或阿尔茨海默氏症等神经系统疾病患者的生活质量。</p>

            <p>根据不同类型来施加刺激的技术，在恢复记忆功能方面具有十分重要的意义，但从概念验证到实际治疗仍需进行更多的研究。</p>`
        },
        {
            id: 9,
            month: '2018-11',
            day: '23',
            img: require('./../assets/img/artical/medical/10.png'),
            cover: 'static/img/medical/news10.png',
            title: `糖尿病药物研发发现新线索`,
            desc: `胰岛素分泌功能缺陷是引发糖尿病的主要原因，因此，促进胰岛素分泌便成为治疗糖尿病的主攻方向之一。我国科学家领衔联合国际团队，首次解析了胰高血糖素样肽-1受体（即GLP-1R）七次跨膜区的晶体结构并揭示了相关的别构调节机理，将掀起新一轮抗糖尿病药物设计和新药开发的热潮。`,
            content: `<p>胰岛素分泌功能缺陷是引发糖尿病的主要原因，因此，促进胰岛素分泌便成为治疗糖尿病的主攻方向之一。我国科学家领衔联合国际团队，首次解析了胰高血糖素样肽-1受体（即GLP-1R）七次跨膜区的晶体结构并揭示了相关的别构调节机理，将掀起新一轮抗糖尿病药物设计和新药开发的热潮。</p>

            <img src="static/img/medical/10/1.png" />

            <p>胰高血糖素样肽-1受体是国际公认的Ⅱ型糖尿病治疗靶标，目前已有多个靶向该受体的多肽药物上市，年销售总额超过100亿美元。但由于多肽药物必须注射使用的缺陷，靶向GLP-1R的小分子口服药物一直是国际医药产业关注的热点。然而，自2007年王明伟课题组报道全球首个具有体内实验治疗效果的小分子GLP-1R激动剂（Boc5）以来，该领域的研究举步维艰，几无突破。</p>

            <img src="static/img/medical/10/2.png" />

            <p>上海科技大学iHuman研究所宋高洁副研究员和中国科学院上海药物研究所杨德华副研究员等一批科研人员合作攻关，突破了GLP-1R在天然状态下异常不稳定、重组表达产量低的瓶颈，借助小分子拮抗剂进一步稳定受体蛋白，首次获得了该受体七次跨膜区非活化状态的晶体结构，分辨率达到2.7埃。相关发现不仅可帮助理解该家族蛋白的别构调节机理，同时也为研发靶向GLP-1R的小分子口服药物研发奠定了结构生物学基础。</p>`
        },
        {
            id: 8,
            month: '2018-10',
            day: '19',
            img: require('./../assets/img/artical/medical/09.png'),
            cover: 'static/img/medical/news9.png',
            title: `80%心脏骤停发生在家中 不足1%患者被救活`,
            desc: `“我国每年大约有54万人死于心脏性猝死，相当于每分钟就有一个人死于心脏性猝死。”广州市妇儿中心医务部主任孙新昨天接受记者采访时指出，国内学校、地铁、大型商场等很多公共场所不但缺乏相应的急救工具，更缺接受过专业培训的急救人员。目前我国心跳骤停急救成功率不到1%.......`,
            content: `<p>“我国每年大约有54万人死于心脏性猝死，相当于每分钟就有一个人死于心脏性猝死。”广州市妇儿中心医务部主任孙新昨天接受记者采访时指出，国内学校、地铁、大型商场等很多公共场所不但缺乏相应的急救工具，更缺接受过专业培训的急救人员。目前我国心跳骤停急救成功率不到1%，而发达国家存活率达到60%。他呼吁有条件的大型机构组织相关人员接受急救培训，以便在意外随时发生时能把握好最初4~6分钟的最佳急救时间，减少心脏性猝死的发生。</p>

            <img src="static/img/medical/9/1.png" />

            <p>遇到有人出现心跳和呼吸骤停，除了及时拨打120外，第一时间该做什么？很多人想到嘴对嘴做“人工呼吸”，这确实是心肺复苏术的重要环节。但美国心脏协会(AHA)近年新订的《心肺复苏和心血管急救指南》建议成年人及儿科病人(新生儿除外)的心肺复苏程序应从“气道、呼吸、胸外心脏按压”改为“胸外心脏按压、气道、呼吸”，也就是建议先“动手”再“动口”。</p>

            <p>专家提醒，没有操作经验的现场目击人员实施心肺复苏术，按压胸部时可简单记住两个要诀——“快”和“深”，在专业救护人员出现前这种抢救不能停。因为一旦中断，患者血液里的氧气难以输送到脑部，易出现脑缺氧。</p>

            <p>快：<br />&emsp;&emsp;按压胸部时每分钟至少要在100次以上；按压胸部和人工呼吸的比率为30∶2，即每按压30次接着做两次人工呼吸；一般按压30次不要超过18秒，人工呼吸时每次吹气应持续1秒钟以上。<br />&emsp;&emsp;深：<br />&emsp;&emsp;做胸外心脏按压时，幅度要足够深。以成人为例，按压下去要使胸骨下陷至少5厘米，以助于患者的心脏收缩和血液向全身输送。</p>`
        },
        {
            id: 7,
            month: '2018-10',
            day: '18',
            img: require('./../assets/img/artical/medical/08.png'),
            cover: 'static/img/medical/news8.png',
            title: `生气到底有多伤身？增加癌症猝死几率缩短寿命`,
            desc: `伤心脏。哈佛大学医学院一项为期20年的跟踪研究发现，生气会导致心梗（MI）或急性冠脉综合征（ACS）危险增加4.74倍。另一项研究发现，与善于控制情绪的人相比，健康的爱发脾气者罹患心脏病而死亡的几率高出19%，爱生气的心脏病患者死亡率更是增加24%。`,
            content: `<p>1．伤心脏。哈佛大学医学院一项为期20年的跟踪研究发现，生气会导致心梗（MI）或急性冠脉综合征（ACS）危险增加4.74倍。另一项研究发现，与善于控制情绪的人相比，健康的爱发脾气者罹患心脏病而死亡的几率高出19%，爱生气的心脏病患者死亡率更是增加24%。</p>

            <p>2．伤肝脏。美国维吉尼亚大学的一项研究发现，生气会导致慢性丙肝病人病情加重。杜克大学的研究发现，爱生气、充满敌意和轻中度抑郁人群体内C反应蛋白（CRP）水平更高。《动脉硬化血栓血管生物学》杂志刊登以色列一项研究发现，CRP水平升高与肝炎和肝损伤关联密切。</p>

            <p>3．伤肺脏。美国马萨诸塞州史密斯学院生理学专家贝妮塔·杰克逊博士及其同事完成的一项研究表明，年龄越大，越容易生气，肺功能也越差。生气时情绪激动过度，呼吸急促，甚至出现过度换气。结果造成肺泡持续扩张，得不到正常放松和休息，导致肺脏功能失常。专家表示，适当深呼吸，让肺泡得到适当的放松，有益肺脏健康。</p>

            <img src="static/img/medical/8/1.png" />

            <p>4．伤胃肠。纽约西奈山医学院医学教授马克巴比亚斯基完成的研究发现，生气会引起交感神经兴奋，导致胃肠血流量降低，蠕动减速，食欲不振，严重时还可引起胃溃疡。</p>

            <p>5．皮肤愈合慢。美国《大脑、行为和免疫》杂志刊登俄亥俄大学一项研究发现，脾气暴躁的人，身体自我修复能力更差，伤口愈合也更慢。生气会导致人体应激激素皮质醇的增加，皮质醇则会导致与人体组织修复密切相关的两种免疫细胞减少，进而导致皮肤愈合速度大减。</p>

            <p>6．致癌。生气憋闷是导致癌症的快捷方式。美国生理学家爱尔玛博士完成的研究发现，生气10分钟耗费的体能相当于3000米赛跑。长期生气导致的内分泌功能紊乱和人体的免疫功能低下，使得癌症更容易发生。</p>

            <p>7．猝死。《美国心脏病学会杂志》刊登耶鲁大学蕾切尔·兰帕特博士完成的一项研究发现，脾气暴怒的男性不仅容易发生脑卒中，也容易发生猝死。研究发现，生气会对心血管健康产生负面影响。怒发冲冠时，肌肉中血流量高出正常水平，导致心脏供血减少，引发心肌缺血、心律不齐、大脑缺氧、气短、甚至猝死。</p>
            
            <p>8．折寿。研究发现，经常生气的确会缩短寿命。美国杜克大学医学中心专家约翰·巴尔福特对118名参试大学生进行的25年跟踪调查发现，对他人敌视程度高的参试者，50岁前死亡的比率高达近20%。相比之下，“敌视度”最低的参试者50岁前死亡几率仅为5%。</p>`
        },
        {
            id: 6,
            month: '2018-09',
            day: '17',
            img: require('./../assets/img/artical/medical/07.png'),
            cover: 'static/img/medical/news7.png',
            title: `年轻人脑中风要查“心病”20%人有患病可能`,
            desc: `无高血压、高血脂、高血糖等常见的“三高”危险因素，27岁的男青年小司却突发脑中风。怎么回事？日前，河南中医学院第一附属医院脑病一区主任刘向哲就遇到了这样一名患者。经过心脏超声造影检查，发现导致小司中风的罪魁祸首是卵圆孔未闭。`,
            content: `<p>无高血压、高血脂、高血糖等常见的“三高”危险因素，27岁的男青年小司却突发脑中风。怎么回事？日前，河南中医学院第一附属医院脑病一区主任刘向哲就遇到了这样一名患者。经过心脏超声造影检查，发现导致小司中风的罪魁祸首是卵圆孔未闭。</p>

            <p>什么是卵圆孔未闭？刘向哲介绍说，卵圆孔是位于两个心房之间的一个通道，在胎儿时期，人体从羊水中吸取营养，这个通道是开放的，等到胎儿出生之后，这个通道就关闭了。但大约有20%的人卵圆孔关闭并不牢靠，在某一个时间又会打开。在发生卵圆孔未闭时，有一部分患者会在静脉中形成血栓，等血栓到达左心房，血栓随血液运行，从而导致脑中风。</p>

            <p>“与心脏有关的脑中风，常见的有心房纤颤、风湿性或非风湿性心瓣膜病、心肌病、心脏传导阻滞、心功能不全等，这些疾病继发脑中风主要见于中老年人。”刘向哲说，年轻人由心脏病继发的脑中风，见于阵发性房颤患者、主动脉弓粥样硬化病变、主动脉夹层、先心病患者（如卵圆孔未闭）等。但是，由于年轻人身强力壮，在急性发病后，这些原发性隐匿病易被漏诊。</p>

            <p>刘向哲说，生活中，对于年轻患者，心脏的常规检查容易被忽视，这多与以下因素有关：</p>

            <img src="static/img/medical/7/1.png" />

            <p>1.由于身体健康，抵抗力强，在脑中风急性发病后，通常不会考虑心脏的问题。</p>

            <p>2.患脑中风后，常规的心电图检查及体检不能发现心脏的微小病变，从而不会做心脏方面的进一步检查。</p>

            <p>3.第一时间到基层医院就诊，即使考虑可能是心脏的问题，但因检查设备及检查医师水平的限制，往往易漏诊。</p>

            <p>4.即使第一时间到省市级医院就诊，中风患者也通常不会做心脏彩超检查，加上TCD发泡试验未能普及，故潜在性心脏疾患易漏诊。</p>

            </p>刘向哲提醒，遇到年轻人患脑中风，如果无“三高”等危险因素，一定不要忘了查心脏的毛病，及时行经食道超声心动图（TEE）及TCD盐水激发试验等相关检查，以免漏诊潜在性疾患，贻误病情。</p>`
        },
        {
            id: 5,
            month: '2018-08',
            day: '15',
            img: require('./../assets/img/artical/medical/06.png'),
            cover: 'static/img/medical/news6.png',
            title: `身体缺铁7个表现：指甲变脆 肌肉酸痛 皮肤苍白`,
            desc: `美国疾控中心最新数据显示，10个成年女性中就有1个身体缺铁。如何早期发现身体是否缺铁呢？美国《女性健康》杂志载文，刊出“身体缺铁的7个信号”。`,
            content: `<p>铁是人体含量的必需微量元素，人体内铁的总量约4—5克，是血红蛋白的重要部分，人全身都需要它，这种矿物质而已存在于向肌肉供给氧气的红细胞中，还是许多酶和免疫系统化合物的成分，人体从食物中摄取所需的大部分铁，并小心控制着铁含量。</p>

            <p>铁对人体的功能表现在许多方面，铁参与氧的运输和储存。红细胞中的血红蛋白是运输氧气的载体;铁是血红蛋白的组成成分，与氧结合，运输到身体的每一个部分，供人们呼吸氧化，以提供能量(能量食品)，消化(消化食品)食物，获得营养;人体内的肌红蛋白存在于肌肉之中，含有亚铁血红素，也结合着氧，是肌肉中的“氧库”。当运动(运动食品)时肌红蛋白中的氧释放出来，随时供应肌肉活动所需的氧。心、肝、肾这些具有高度生理活动能力和生化功能的细胞线粒体内，储存的铁特别多，线粒体是细胞的“能量工厂”，铁直接参与能量的释放。</p>

            <img src="static/img/medical/6/1.png" />

            <p>1．疲劳乏力。范德比尔特综合健康中心专家布莱尔·莫里斯表示，“铁是组成血红蛋白的重要成分，以帮助氧气传输至身体各部分。体内健康血细胞一旦不足，就会感到筋疲力尽。</p>

            <p>2．注意力难集中。莫里斯表示，在缺铁的人群中，神经递质素合成可能发生改变，进而导致注意力不集中等功能失常问题。</p>

            <p>3．指甲变脆。缺铁会导致手指甲及脚趾甲变薄变脆，更容易折断。指甲出现凹陷或者勺状也是缺铁的明显症状。</p>

            <p>4．呼吸不畅。美国纽约营养学专家金伯利·穆勒博士表示，人体一旦缺铁，健身时或者平常走路时往往会感到气喘吁吁，上气不接下气。其原因是，缺铁会导致血氧量降低。</p>

            <p>5．皮肤异常苍白。穆勒博士表示，年纪轻轻看上去面色苍白，这可不是好事。皮肤异常苍白是血流量降低和红细胞减少的典型症状。</p>

            <p>6．难以进行正常锻炼。几周前还可以正常锻炼，但现在完成同样的运动量却感觉非常吃力。这是因为血铁水平过低严重影响了耐力。</p>

            <p>7．肌肉酸痛。身体缺铁，浑身没劲，勉强健身更容易导致运动后更长时间的肌肉酸痛。因为缺铁会延长肌肉恢复期。</p>`
        },
        {
            id: 4,
            month: '2018-07',
            day: '02',
            img: require('./../assets/img/artical/medical/05.png'),
            cover: 'static/img/medical/news5.png',
            title: `夏季创伤易发误用粉剂止血 伤口较浅可压迫止血`,
            desc: `近日，有关新鲜创面是否能使用粉剂止血护理的争议在业内引起关注，甚至有医生在微博上晒出有儿童贸然使用粉剂止血留下疤痕的照片，而2012年就曾有报道称：“家长在女儿皮肤擦伤后用红汞+云南白药粉，导致表皮坏死、毁容基本确定。”粉剂止血不可贸然使用？专家在接受采访时表......`,
            content: `<p>近日，有关新鲜创面是否能使用粉剂止血护理的争议在业内引起关注，甚至有医生在微博上晒出有儿童贸然使用粉剂止血留下疤痕的照片，而2012年就曾有报道称：“家长在女儿皮肤擦伤后用红汞+云南白药粉，导致表皮坏死、毁容基本确定。”粉剂止血不可贸然使用？专家在接受采访时表示，伤口首先应清洗干净，至于止血药物，与形态并没有太大的关系，最关键的一点是要保证无菌，避免引起伤口感染等。</p>

            <img src="static/img/medical/5/1.png" />

            <p>粉剂止血临床已基本淘汰</p>

            <p>西城区红十字会急救指导老师崔世宝告诉记者，粉剂止血在临床中已经基本淘汰，现在一般也不会用粉剂止血。这种止血方法之所以被淘汰，是因为粉剂容易造成伤口化脓，甚至可能导致感染。</p>

            <p>针对案例中提到的情况，利用粉剂止血反而留疤，崔世宝表示，正是因为使用粉剂不当导致了伤口感染，伤口已经不仅仅在皮肤表皮层，流脓、出水也预示已经伤及皮肤真皮层，这也是导致留疤的原因。</p>

            <p>粉剂止血关键要保证无菌</p>

            <p>首都医科大学附属北京地坛医院皮肤性病科主任伦文辉说，在新鲜创面上涂抹粉剂进行止血，皮肤无法吸收粉剂，而有些粉剂自身不一定是无菌的，直接接触创面，可能会造成感染。总的来说，能否用于止血与具体形态没有太大关系，关键要保证这些物质是无菌的。</p>

            <p>有一种情况比较特殊，即如果伤口为纵向切口，也不宜使用粉剂止血，因为颗粒状的粉剂附着在伤口附近甚至与伤口聚合在一起，反而阻碍了伤口附近皮肤黏膜细胞的生长，不利于伤口愈合。</p>

            <img src="static/img/medical/5/2.png" />

            <p>粉剂止血临床已基本淘汰</p>

            <p>西城区红十字会急救指导老师崔世宝告诉记者，粉剂止血在临床中已经基本淘汰，现在一般也不会用粉剂止血。这种止血方法之所以被淘汰，是因为粉剂容易造成伤口化脓，甚至可能导致感染。</p>

            <p>针对案例中提到的情况，利用粉剂止血反而留疤，崔世宝表示，正是因为使用粉剂不当导致了伤口感染，伤口已经不仅仅在皮肤表皮层，流脓、出水也预示已经伤及皮肤真皮层，这也是导致留疤的原因。</p>

            <p>粉剂止血关键要保证无菌</p>

            <p>首都医科大学附属北京地坛医院皮肤性病科主任伦文辉说，在新鲜创面上涂抹粉剂进行止血，皮肤无法吸收粉剂，而有些粉剂自身不一定是无菌的，直接接触创面，可能会造成感染。总的来说，能否用于止血与具体形态没有太大关系，关键要保证这些物质是无菌的。</p>

            <p>有一种情况比较特殊，即如果伤口为纵向切口，也不宜使用粉剂止血，因为颗粒状的粉剂附着在伤口附近甚至与伤口聚合在一起，反而阻碍了伤口附近皮肤黏膜细胞的生长，不利于伤口愈合。</p>`
        },
        {
            id: 3,
            month: '2018-05',
            day: '06',
            img: require('./../assets/img/artical/medical/04.png'),
            cover: 'static/img/medical/news4.png',
            title: `家庭药箱：忘了吃药怎么补救？`,
            desc: `计算错过的时间，判断是否需要补服。并不是所有漏服情况都要补。一般来说，如果发现漏服的时间处于两次用药时间间隔一半内，可按量补服；如果超过此间隔的一半以上，一般不需要再补服。此规则适用于多数非处方药和部分处方药，但降压、降糖药的用法，需要根据具体情况处理。`,
            content: `<p>建议大家漏服药物时，根据以下几点处理。</p>

            <p>算：计算错过的时间，判断是否需要补服。并不是所有漏服情况都要补。一般来说，如果发现漏服的时间处于两次用药时间间隔一半内，可按量补服；如果超过此间隔的一半以上，一般不需要再补服。此规则适用于多数非处方药和部分处方药，但降压、降糖药的用法，需要根据具体情况处理。例如磺脲类降糖药，应在早餐前半小时服用，每日一次。万一漏服了，如果能在午饭前想起，可根据血糖情况按照原来的剂量补服。如果时间已过午餐，就要视情况减量补服。</p>

            <p>定：能够补服的药物，下次服药的间隔时间不变。补服药物后，下次服药不能再按照平常的时间，而应保证服药间隔，以免造成药物浓度过高，增大发生不良反应的风险。例如每天需要服用3次的抗生素，不是跟着三餐服用，而是每隔8小时服一次。如果早上7点吃药，本应下午3点再服一次，若到了4点才想起来吃，那第三次服药的时间也应向后推1小时。</p>

            <img src="static/img/medical/4/1.png" />

            <p>过：如果超过了补服的时间，应分情况处理。例如长效降压药每天只需要服用一次，在服药后的48小时甚至72小时内，血液中的药物还能维持一定的浓度，所以短时间漏服后，血压也可被控制在一定范围内，一般不建议补服，下次按时间吃药即可。但是，如果漏服时间较长，并且血压波动较大，则应当咨询医生后，加服一次短效降压药，之后按正常周期服药。又例如，需要每天服3次糖皮质激素类药物的患者，如果到了下次服药时才发现漏服，可遵医嘱加倍剂量服用，此后按照正常剂量和时间服用。</p>

            <p>调：补服后，必要时应调整后续的服用时间。有些特殊情况，补服后还需要调整服用时间，以保证治疗效果。例如进行移植和心脏瓣膜置换的患者需要长期服抗凝药，如果漏服1次，在后续的12天内应逐步调整，直至恢复到原来的服药时间。</p>`
        },
        {
            id: 2,
            month: '2018-03',
            day: '24',
            img: require('./../assets/img/artical/medical/03.png'),
            cover: 'static/img/medical/news3.png',
            title: `久坐起身快易损伤心血管`,
            desc: `在忙碌的生活中，你是否留意看看我们的身边，很多年轻人上班一坐就是一整天，盯着电脑几乎不动弹，甚至连吃饭也是叫外卖；回家后依然是窝在沙发上看电视、电脑或者玩游戏打通宵。虽然与上班族不同但是这样一个群体你也一定见多不怪了吧：常常能见到天气好时路边一片片的老年人......`,
            content: `<p>在忙碌的生活中，你是否留意看看我们的身边，很多年轻人上班一坐就是一整天，盯着电脑几乎不动弹，甚至连吃饭也是叫外卖；回家后依然是窝在沙发上看电视、电脑或者玩游戏打通宵。</p>

            <p>虽然与上班族不同但是这样一个群体你也一定见多不怪了吧：常常能见到天气好时路边一片片的老年人专注于牌桌和棋盘，一玩就是大半天；连自己的小孙子孙女都不管不顾。我们还见到，很多原本应该蹦蹦跳跳的青少年，也被电脑、手机吸引住，户外活动却是越来越少。<br />&emsp;&emsp;久坐不动——不仅会带来肥胖、颈腰椎病等问题，它还像多米诺骨牌一样，对心脑血管形成一连串的损伤，久坐之后猛起身，就是一个危险“杀手”。</p>

            <img src="static/img/medical/3/1.png" />

            <p>首先，长时间保持同一姿势坐立，下肢肌肉收缩活动相对减少，导致人体血液的流速减慢，血液黏稠度增高，为深静脉血栓的形成创造了条件；加之老年人基础疾病较为普遍，血管本身受损就很严重，如果此时再猛然活动，如猛地起身伸腰、大幅度摆动胳膊等，很容易牵动不稳定的血栓，使之脱落造成血栓栓塞，引起相应部位的缺血、缺氧等症状。更为严重的是，如果血栓游离到肺部，可能堵住肺动脉造成肺栓塞，严重者短时间内就会危及生命。有调查发现，近年来不少“白领精英”的猝死，就与肺栓塞有关。</p>

            <p>其次，长时间同一姿势后突然变换体位，很容易造成血压波动，出现“体位性低血压”，使心脑等器官供血不足，严重时出现心悸、头晕、头痛，甚至反复晕厥或诱发脑卒中。即使是较为年轻的中青年也会出现一过性的眼前发黑等症状，因此体位性低血压应该引起人们的高度重视。</p>

            <p>最后，对中老年人和心脑血管疾病患者来说，由于血管柔韧度较差，久坐后猛然牵拉，还可能“撕裂”血管，诱发“主动脉夹层”等严重后果，如抢救不及时，其死亡率达到30%~40%。</p>

            <img src="static/img/medical/3/2.png" />

            <p>因此，我们有必要正视久坐的危害。老年人、长时间坐姿和伏案工作者等，要有意识地“动起来”，最好每隔1~2小时起身活动一会儿，慢慢伸个懒腰、甩甩胳膊，松弛一下脊柱；或者通过绷脚尖、翘脚趾等活动踝关节，促进下肢的血液回流。</p>

            <p>打牌等娱乐活动要有时间限制。一旦发现腿脚明显肿胀，不要随意用力按摩、拍打等，而要在医生指导下抚触下肢，以免血栓脱落。起身后，如出现胸闷憋气、呼吸急促、剧烈胸痛等症状，要立即就医。</p>

            <p>有冠心病史的老年患者，可平时服些安全性较高、具有修复受损血管内皮作用的中成药如通心络胶囊，它能够清除血液中增高的脂质，保护血管内皮，改善血管内皮功能，稳定易损斑块防止血栓形成，延长心脑组织在缺血缺氧环境中的存活时间，是临床用于心脑血管疾病的一级预防的必备药物。</p>`
        },
        {
            id: 1,
            month: '2018-02',
            day: '28',
            img: require('./../assets/img/artical/medical/02.png'),
            cover: 'static/img/medical/news2.png',
            title: `眩晕的年轻人 越来越多`,
            desc: `眩晕是患者的一种主观感受，是门、急诊最常见的临床症候群之一，最新临床调查统计的结果显示，眩晕发病率为8%。由于人们的生活和工作压力的增大，年轻人患上眩晕症的比例也在不断的上升。日前，《2012年中国康复医学会颈椎病专业委员会眩晕研究学组成立大会暨眩晕多学科研讨会......`,
            content: `<p>眩晕是患者的一种主观感受，是门、急诊最常见的临床症候群之一，最新临床调查统计的结果显示，眩晕发病率为8%。由于人们的生活和工作压力的增大，年轻人患上眩晕症的比例也在不断的上升。日前，《2012年中国康复医学会颈椎病专业委员会眩晕研究学组成立大会暨眩晕多学科研讨会》在中日友好医院召开，多学科的专家们希望建立眩晕疾病的诊疗流程，让患者就诊少走弯路。</p>

            <img src="static/img/medical/2/1.png" />

            <p>眩晕症几乎涉及十余个学科几十种疾病，北京协和医院耳鼻喉科蒋子栋医生说，有眩晕症状的病人占一个医院门诊病人的1/4到1/3左右，内科、眼科、神经科、骨科、耳鼻喉科、中医科、老年科、血液科、心理科等都会碰到眩晕的患者。所以，眩晕可视为一种交叉学科疾病，要求医生具有广博的医学理论基础及丰富的临床经验，并能适时吸取国外先进经验。而目前国内不同地区、不同医院、不同科室从不同角度来诊治研究眩晕症，难免造成片面诊治和重复诊治，导致了一些不必要的医疗资源浪费，从而增加了患者和国家的医疗负担。中日友好医院脊柱外科主任李中实教授指出，眩晕研究学组的成立要解决两个问题，一是看病，病人在第一次就诊时判定是否属自己所在科室的诊治范围；二是分流，如果不属自己所在科室的诊治范围，把病人转诊到他应该去的科室，让病人就诊少走弯路。</p>

            <p>有人不把眩晕当回事，蒋子栋医生说，“在美国，人们很关注眩晕，因为眩晕的时候没有先兆，发作起来很危险，尤其开车的时候发作，非常危险。”在日常生活中发生眩晕最危险的是摔倒，尤其是老人，摔倒易发生骨折，长期卧床会导致肺炎、血栓等问题。</p>

            <p>由于颈椎的支持结构远不如胸椎、腰椎和骶椎稳固，而且在日常工作、生活中颈椎活动度最大最频繁，因此，易发生损伤、退变和不稳。年轻人长时间看电脑导致越来越多的人患有颈椎病，李中实教授介绍说，在50岁以上的眩晕患者中，50%为颈性眩晕。颈性眩晕是由颈椎病引起的，主要症状是：眩晕，可伴有恶心、呕吐、头颈痛、耳鸣、视觉障碍、出汗、心悸、肩背痛、潮红及上肢麻木等，其表现可呈多样化组合形式。“结合大量的临床实践，我们观察到颈性眩晕多在起床、翻身、低头、扬头等头颈部转动或体位改变时发生，劳累后容易发作或加重，休息或经颈托外固定治疗可以减轻。”</p>`
        },
        {
            id: 0,
            month: '2018-01',
            day: '21',
            img: require('./../assets/img/artical/medical/01.png'),
            cover: 'static/img/medical/news1.png',
            title: `三大恶习致感冒久治不愈：紧闭门窗 服抗生素`,
            desc: `很多人换上感冒后久治不愈，这是怎么回事呢，除了跟天气的原因以外更重要的是你一定有下面这三大恶习。快来看看吧，如果是那么赶快改掉，否则你的感冒还是难以痊愈。1：咳嗽、打喷嚏时用手捂嘴，很多人在咳嗽、打喷嚏时会下意识用手捂嘴，这样看起来很有礼貌，却不知道这样做......`,
            content: `<p>很多人换上感冒后久治不愈，这是怎么回事呢，除了跟天气的原因以外更重要的是你一定有下面这三大恶习。快来看看吧，如果是那么赶快改掉，否则你的感冒还是难以痊愈。</p>

            <p>1：咳嗽、打喷嚏时用手捂嘴<br />&emsp;&emsp;很多人在咳嗽、打喷嚏时会下意识用手捂嘴，这样看起来很有礼貌，却不知道这样做细菌会直接附着到手上，然后再用这只手触摸别处时，细菌会加倍增加。<br />&emsp;&emsp;2003年抗非典英雄罗翌教授解释称“人在咳嗽、打喷嚏时，细菌会扩散到空气中，然后瞬间落到地面变干，但是用手捂嘴的话，手会变湿，这就为病毒、细菌提供了适宜的生存环境”。<br />&emsp;&emsp;因此作为对策，咳嗽、打喷嚏时不要用手捂嘴，可以用手臂或是面巾纸代替。而用手捂过嘴之后，应该立即洗手。</p>

            <img src="static/img/medical/1/1.png" />

            <p>2：紧闭门窗，以保证室温<br />&emsp;&emsp;感冒、流感大多在冬季流行，不过这与气温并没有关系。事实上，常在户外活动、晒太阳的孩子要比呆在屋里的孩子更少感染病毒。更有研究表明，人长期呆在通风不畅的房间内，呼吸系统疾病会更严重。</p>
            
            <p>3：感冒后立服用喝含抗生素的药<br />&emsp;&emsp;“是不是感冒了？”，很多人刚一这样想，就立即跑去开含抗生素的药，但是抗生素对于治疗感冒并没有效果。因为感冒是由于病毒引发的，而抗生素并不能杀死病毒，而是会杀死病毒。不仅如此，抗生素还会杀死大量可以提高免疫力的良性细菌，起到适得其反的作用。<br />&emsp;&emsp;广东省中医院急诊科原主任罗翌提醒大家，当刚出现打喷嚏、流鼻涕、发烧等感冒症状时，应及时选用既能解除感冒症状、又能抗感冒流感病毒的感冒药。</p>`
        },
    ],
    medicalArticalId: 0,
}

const mutations = {
    changeId(state, index) {
        state.productId = index;
    },
    changeListId(state, index) {
        state.listId = index;
    },
    changehealthArticalId(state, index) {
        state.healthArticalId = index;
    },
    changetravelArticalId(state, index) {
        state.travelArticalId = index;
    },
    changehorseArticalId(state, index) {
        state.horseArticalId = index;
    },
    changemedicalArticalId(state, index) {
        state.medicalArticalId = index;
    },
    changeSelectLanguage(state, index) {
        state.selectLanguage = index;
    }
}

const store = new Vuex.Store({
    state,
    mutations
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js